<template>
    <div>
        <div class="d-sm-block d-mb-block d-lg-none" v-if="isMobile">
            <div class="main-container-mobile">

                <!-- Блок 1 (Мобильный): Hero Section -->
                <div class="first-container-mobile">
                    <div class="first-block-mobile">
                        <div class="logo-container-mobile">
                            <img src="../assets/img/park-live-logo-mobile.svg" alt="Absolut Tabasco Logo" class="brand-logo-mobile" />
                        </div>
                        <!-- <h1 class="hero-title-mobile">
                            ABSOLUT<span class="symbol-reg">®</span> TABASCO<span class="symbol-tm">™</span>
                        </h1> -->
                        <h2 class="hero-subtitle-mobile">
                            CHILI PEPPER FLAVORED VODKA
                        </h2>
                        <p class="hero-desc-mobile">
                            Коллаборация двух уникальных брендов.
                        </p>

                        <div class="hero-buttons-mobile">
                            <!-- <button @click="scrollToForm" class="btn-primary-mobile">
                                ПОПРОБОВАТЬ НА PARK LIVE
                            </button> -->
                            <button @click="scrollToRecipe" class="btn-secondary-mobile">
                                РЕЦЕПТЫ <span class="arrow-icon">→</span>
                            </button>
                        </div>

                        <!-- Изображение продукта -->
                        <!-- <div class="product-image-container-mobile mt-4">
                            <div class="lava-glow-mobile"></div>
                            <img src="../assets/img/absolut-second-block-img.png" alt="Absolut Tabasco Bottle" class="product-img-mobile" />
                        </div> -->

                        <!-- Таймер главной акции -->
                        <!-- <div v-if="!isFinished" class="countdown-wrapper-mobile mt-4">
                            <div class="countdown-item-mobile">
                                <span class="countdown-number">{{ padNumber(days) }}</span>
                                <span class="countdown-label">ДНЕЙ</span>
                            </div>
                            <div class="countdown-item-mobile">
                                <span class="countdown-number">{{ padNumber(hours) }}</span>
                                <span class="countdown-label">ЧАСОВ</span>
                            </div>
                            <div class="countdown-item-mobile">
                                <span class="countdown-number">{{ padNumber(minutes) }}</span>
                                <span class="countdown-label">МИНУТ</span>
                            </div>
                            <div class="countdown-item-mobile">
                                <span class="countdown-number">{{ padNumber(seconds) }}</span>
                                <span class="countdown-label">СЕКУНД</span>
                            </div>
                        </div>

                        <div v-else class="finished-message mt-4">
                            <p>Уже здесь</p>
                            <a href="#" class="finished-link">Перейти по ссылке</a>
                        </div> -->
                    </div>
                </div>

                <!-- Блок 2 (Мобильный): История коллаборации и характеристики -->
                <div class="second-container-mobile">
                    <div class="second-content-mobile">
                        <p class="eyebrow-text-mobile">История коллаборации</p>
                        <h2 class="second-title-mobile">
                            КОГДА<br>
                            ВСТРЕЧАЮТСЯ<br>
                            ДВЕ ИКОНЫ
                        </h2>
                        <div class="second-desc-mobile">
                            <p>
                                Absolut — водка, которая с 1879 года делается в шведской деревне Охус из озимой пшеницы одного региона. Tabasco® — соус, который семья Макайленни производит на острове Эйвери-Айленд с 1868 года.
                            </p>
                            <p>
                                Absolut Tabasco — первая коллаборация двух легенд: премиум водка с характером настоящего перечного соуса. Созданa для одного — зажечь ваши коктейли.
                            </p>
                        </div>

                        <!-- Сетка характеристик 2x2 -->
                        <div class="features-grid-mobile mt-4">
                            <div class="feature-item-mobile border-bottom border-right">
                                <span class="feature-value">38%</span>
                                <span class="feature-label">Крепость</span>
                            </div>
                            <div class="feature-item-mobile border-bottom">
                                <span class="feature-value">0 г</span>
                                <span class="feature-label">Сахара</span>
                            </div>
                            <div class="feature-item-mobile border-right">
                                <span class="feature-value">100%</span>
                                <span class="feature-label">Настоящий Tabasco®</span>
                            </div>
                            <div class="feature-item-mobile">
                                <span class="feature-value">GLUTEN</span>
                                <span class="feature-label">Free</span>
                            </div>
                        </div>

                        <!-- Презентация продукта -->
                        <div class="product-presentation-mobile mt-5">
                            <div class="red-radial-glow-mobile"></div>
                            <img src="../assets/img/park-live-second-block-img-mobile.png" alt="Absolut Tabasco Bottle Close-Up" class="bottle-detail-img-mobile" />
                            <!-- <div class="chili-peppers-container-mobile">
                                <img src="../assets/img/absolut-second-block-img.png" alt="Red Chili Peppers" class="chili-img-mobile" />
                            </div> -->
                        </div>

                        <!-- Сноска -->
                        <p class="legal-footnote-mobile mt-4">
                            ENJOY RESPONSIBLY. TABASCO AND THE DIAMOND LOGO ARE REGISTERED TRADEMARKS OF MCILHENNY COMPANY.
                        </p>
                    </div>
                </div>

                <!-- Блок 3 (Мобильный): Секция рецептов -->
                <div class="recipes-container-mobile" ref="recipeSectionMobile" id="recipes-container-mobile">
                    <div class="recipes-content-mobile">
                        <p class="recipes-eyebrow-mobile">Рецепты</p>
                        <h2 class="recipes-title-mobile">ДВА ФИРМЕННЫХ КОКТЕЙЛЯ</h2>
                        <p class="recipes-subtitle-mobile">
                            Рецепты разработаны нашими опытными бартендерами.Открой карточку - внутри пошаговый рецепт!
                        </p>

                        <!-- Карусель карточек рецептов -->
                        <div class="carousel-outer-mobile mt-4">
                            <button @click="prevRecipeSlide" class="carousel-arrow-mobile arrow-left-mobile" aria-label="Предыдущий">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>

                            <div class="carousel-viewport-mobile">
                                <div class="recipes-cards-track" :style="{ transform: `translateX(-${recipeCarouselIndex * 100}%)` }">
                                    <div v-for="recipe in recipes" :key="recipe.id" class="recipe-card-slide-mobile">
                                        <div class="recipe-card-mobile">
                                            <div class="recipe-card-bg">
                                                <img :src="recipe.image" :alt="recipe.title" class="recipe-card-img" />
                                                <div class="recipe-card-overlay"></div>
                                            </div>
                                            <div class="recipe-card-body">
                                                <h3 class="recipe-card-title">{{ recipe.title }}</h3>
                                                <p class="recipe-card-subtitle">{{ recipe.subtitle }}</p>
                                                <button @click="openRecipeModal(recipe)" class="btn-recipe-view">
                                                    Смотреть рецепт <span class="arrow-icon">→</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button @click="nextRecipeSlide" class="carousel-arrow-mobile arrow-right-mobile" aria-label="Следующий">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 18L15 12L9 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>

                        <!-- Пагинация -->
                        <div class="carousel-pagination mt-4">
                            <span 
                                v-for="(recipe, index) in recipes" 
                                :key="recipe.id"
                                :class="['pagination-dot', { active: index === recipeCarouselIndex }]"
                                @click="setRecipeSlide(index)"
                            ></span>
                        </div>
                    </div>
                </div>

                <!-- Блок 4 (Мобильный): Регистрация на Park Live (скрыт, так как мероприятие прошло) -->
                <!-- <div class="third-container-mobile" ref="formSectionMobile" id="registration-form-mobile">
                    <div class="reg-content-mobile">
                        <div class="reg-left-mobile">
                            <div class="reg-badge-pill-mobile">
                                Розыгрыш открыт до 20 августа, 20:00
                            </div>
                            <p class="reg-eyebrow-mobile">PARK LIVE • АЛМАТЫ • 21–23 АВГУСТА</p>
                            <h2 class="reg-title-mobile">
                                ПОПРОБУЙ ПЕРВЫМ —<br>
                                HA PARK LIVE
                            </h2>
                            <p class="reg-paragraph-mobile">
                                Зона Absolut Tabasco - это бар с крутыми коктейлями и активностями от бренда.
                            </p>
                            <p class="reg-paragraph-mobile">
                                Разыгрываем 2 абонемента на 3 дня в одни руки среди всех, кто заполнит анкету для участия.
                            </p>
                            <p class="reg-paragraph-mobile">
                                <a @click="openPopup('rules')" style="text-decoration: underline; cursor: pointer;">Ознакомиться с полными правилами активностями</a>
                            </p>
                        </div>

                        <div class="reg-right-mobile mt-4">
                            <div class="form-card-container-mobile">
                                <h3 class="form-card-title-mobile">ХОЧУ НА PARK LIVE</h3>
                                <p class="form-card-subtitle-mobile">
                                    Заполни форму - получи возможность стать обладетелем абонементов на 3 дня.
                                </p>

                                <div v-if="isLoadingForm" class="form-loading">
                                    <v-progress-circular indeterminate size="48" color="#FFFFFF" />
                                </div>
                                <div v-else-if="formError" class="form-error">
                                    <p class="form-error-text">Ошибка загрузки формы. Попробуйте позже.</p>
                                    <button class="btn-form-outline-mobile mt-4" @click="getFormFields">Повторить попытку</button>
                                </div>
                                <div v-else class="form-main-mobile-card">
                                    <div v-for="question in normalQuestions" :key="question.id" class="form-group-mobile">
                                        <label class="form-input-label-mobile">{{ question.name }}</label>
                                        <div class="input-wrapper-mobile">
                                            <input 
                                                v-if="[1, 2, 7, 10].includes(question.type)" 
                                                class="input-body-mobile-card"
                                                v-model="formData[question.id]" 
                                                :placeholder="getPlaceholder(question)"
                                                @blur="markTouched(question)" 
                                                @input="validateField(question)" 
                                            />
                                            <input 
                                                v-else-if="question.type === 4" 
                                                class="input-body-mobile-card"
                                                v-model="formData[question.id]" 
                                                v-mask="'+7(###) ###-##-##'"
                                                placeholder="+7 (7__) ___-__-__" 
                                                @blur="markTouched(question)"
                                                @focus="onPhoneFocus(question)" 
                                                @input="onPhoneInput(question)" 
                                            />
                                            <v-select 
                                                v-else-if="[5, 9, 6].includes(question.type)" 
                                                v-model="formData[question.id]"
                                                :items="question.answers" 
                                                item-text="name" 
                                                item-value="id" 
                                                dense 
                                                outlined
                                                hide-details 
                                                :placeholder="getPlaceholder(question)" 
                                                class="card-select-mobile"
                                            >
                                                <template v-slot:selection="{ item }">
                                                    <div class="select-input" style="white-space: normal; word-break: break-word;">
                                                        {{ item.name }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="error-message">
                                                <span v-show="errors[question.id]">{{ errors[question.id] }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="checkboxes-wrapper-mobile mt-3">
                                        <div v-for="question in filteredQuestions" :key="question.id" class="checkbox-container-card">
                                            <div class="checkbox-content-card">
                                                <input 
                                                    class="custom-checkbox-card" 
                                                    type="checkbox" 
                                                    v-model="formData[question.id]"
                                                    :id="'mob_' + question.id" 
                                                    @change="markTouched(question)"
                                                    @input="validateField(question)" 
                                                />
                                                <label class="checkbox-label-card" :for="'mob_' + question.id">
                                                    <template v-if="question.number === 7">
                                                        Я даю согласие на
                                                        <a class="legal-link" @click.stop.prevent="openPopup('offer')">
                                                            сбор и обработку персональных данных
                                                        </a>
                                                    </template>
                                                    <template v-else>
                                                        {{ question.name }}
                                                    </template>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="btn-submit-container mt-4">
                                        <button 
                                            @click="confirmRegistration"
                                            class="btn-form-outline-mobile"
                                            :disabled="isSendSms"
                                        >
                                            {{ isSendSms ? "Отправка..." : "УЧАСТВОВАТЬ" }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- Блок 5 (Мобильный): Покупка и Таймер Xo.kz -->
                <div class="fifth-container-mobile">
                    <div class="fifth-content-mobile">
                        <p class="fifth-eyebrow-mobile">ГДЕ КУПИТЬ</p>
                        <h2 class="fifth-title-mobile">УЖЕ В ПРОДАЖЕ</h2>
                        <p class="fifth-subtitle-mobile">
                            Absolut Tabasco появится на Xo.kz 24 августа. Участники розыгрыша получат персональный промокод на скидку 15%.
                        </p>

                        <!-- Таймер -->
                        <div v-if="!isBuyAvailable" class="buy-countdown-grid-mobile mt-3">
                            <div class="buy-countdown-block-mobile">
                                <span class="buy-countdown-number">{{ padNumber(buyDays) }}</span>
                                <span class="buy-countdown-label">ДНЕЙ</span>
                            </div>
                            <div class="buy-countdown-block-mobile">
                                <span class="buy-countdown-number">{{ padNumber(buyHours) }}</span>
                                <span class="buy-countdown-label">ЧАСОВ</span>
                            </div>
                            <div class="buy-countdown-block-mobile">
                                <span class="buy-countdown-number">{{ padNumber(buyMinutes) }}</span>
                                <span class="buy-countdown-label">МИНУТ</span>
                            </div>
                            <div class="buy-countdown-block-mobile">
                                <span class="buy-countdown-number">{{ padNumber(buySeconds) }}</span>
                                <span class="buy-countdown-label">СЕКУНД</span>
                            </div>
                        </div>

                        <!-- Кнопка -->
                        <div class="buy-action-container-mobile mt-4">
                            <button v-if="!isBuyAvailable" class="btn-buy-disabled-mobile" disabled>
                                <svg class="lock-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span>КУПИТЬ — ОТКРОЕТСЯ 24 АВГУСТА</span>
                            </button>
                            <button v-else @click="goToStore" class="btn-buy-active-mobile">
                                <span>КУПИТЬ НА XO.KZ</span>
                                <span class="arrow-icon">→</span>
                            </button>
                        </div>

                        <!-- Инфо-баннер -->
                        <div class="promo-pill-banner-mobile mt-4">
                            <svg class="ticket-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 5V19M4 10C4 10 6 10 6 12C6 14 4 14 4 14V17C4 18.1046 4.89543 19 6 19H18C19.1046 19 20 18.1046 20 17V14C20 14 18 14 18 12C18 10 20 10 20 10V7C20 5.89543 19.1046 5 18 5H6C4.89543 5 4 5.89543 4 7V10Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="promo-pill-text-mobile">Промокод <strong>-15%</strong> — всем участникам розыгрыша</span>
                        </div>
                    </div>
                </div>

                <!-- Подвал (Мобильный) -->
                <div class="main-container-footer-mobile">
                    <div class="footer-container-mobile">
                        <div class="politics-container-mobile">
                            <div class="logo-container-footer">
                                <img src="../assets/img/park-live-footer-logo.svg" alt="" class="jameson-logo-footer-mobile" />
                            </div>
                            <div class="d-flex flex-column">
                                <div class="footer-first-block">
                                    <p class="link-text-mobile pb-5">{{ config.footer.warningText }}</p>
                                    <a class="link-text-mobile" style="text-decoration: underline;"
                                        :href="config.footer.policyLink.href" target="_blank">
                                        {{ config.footer.policyLink.text }}
                                    </a>
                                </div>
                                <div class="footer-second-block mt-5">
                                    <p v-for="(item, index) in config.footer.menuLinks" :key="index"
                                        class="footer-main-text">
                                        <a class="footer-main-text" @click="openPopup(item.href)">{{ item.text }}</a>
                                    </p>
                                </div>
                                <div class="footer-third-block">
                                    <p class="link-text-mobile">
                                        21+. Чрезмерное употребление алкоголя вредит вашему здоровью
                                    </p>
                                    <p class="link-text-mobile mt-2">
                                        Розыгрыш проводится по <a style="text-decoration: underline; cursor: pointer;" @click="openPopup('rules')">официальным правилам</a>. Организатор — Pernod Ricard Kazakhstan. Победителей объявим 20 августа в соцсетях бренда.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="social-container-mobile">
                            <div class="social-icons-container">
                                <div @click="goTo('https://www.instagram.com/weareabsolut')">
                                    <svg width="45" height="45" viewBox="0 0 51 51" fill="#DD1814"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path d="M36.3973 21.1698C36.3467 20.0215 36.161 19.232 35.895 18.548C35.6206 17.8218 35.1984 17.1717 34.6452 16.6313C34.1048 16.0825 33.4504 15.656 32.7327 15.3859C32.0447 15.1199 31.2593 14.9342 30.111 14.8835C28.9541 14.8286 28.5869 14.8159 25.6527 14.8159C22.7185 14.8159 22.3512 14.8286 21.1986 14.8792C20.0503 14.9299 19.2609 15.1157 18.5769 15.3816C17.8507 15.656 17.2006 16.0782 16.6601 16.6313C16.1113 17.1717 15.685 17.8261 15.4147 18.5439C15.1487 19.232 14.963 20.0172 14.9123 21.1655C14.8574 22.3224 14.8447 22.6897 14.8447 25.6239C14.8447 28.5581 14.8574 28.9253 14.9081 30.0779C14.9587 31.2263 15.1445 32.0157 15.4106 32.6998C15.685 33.4259 16.1113 34.076 16.6601 34.6164C17.2006 35.1653 17.8549 35.5918 18.5727 35.8619C19.2609 36.1279 20.046 36.3136 21.1945 36.3642C22.3469 36.415 22.7144 36.4276 25.6486 36.4276C28.5828 36.4276 28.95 36.415 30.1026 36.3642C31.2509 36.3136 32.0404 36.1279 32.7243 35.8619C34.1767 35.3003 35.325 34.152 35.8866 32.6998C36.1524 32.0116 36.3383 31.2263 36.3889 30.0779C36.4395 28.9253 36.4522 28.5581 36.4522 25.6239C36.4522 22.6897 36.4479 22.3224 36.3973 21.1698ZM34.4511 29.9935C34.4046 31.049 34.2273 31.6189 34.0796 31.9989C33.7164 32.9404 32.9692 33.6876 32.0277 34.0508C31.6477 34.1985 31.0736 34.3758 30.0223 34.4222C28.8824 34.473 28.5405 34.4855 25.657 34.4855C22.7734 34.4855 22.4272 34.473 21.2915 34.4222C20.236 34.3758 19.6661 34.1985 19.2861 34.0508C18.8176 33.8776 18.3911 33.6032 18.0449 33.2443C17.6861 32.8939 17.4116 32.4717 17.2385 32.0032C17.0907 31.6232 16.9134 31.049 16.8671 29.9978C16.8163 28.8579 16.8038 28.5159 16.8038 25.6323C16.8038 22.7487 16.8163 22.4026 16.8671 21.267C16.9134 20.2115 17.0907 19.6415 17.2385 19.2616C17.4116 18.7929 17.6861 18.3666 18.0492 18.0202C18.3995 17.6614 18.8217 17.387 19.2904 17.214C19.6703 17.0662 20.2446 16.8889 21.2958 16.8424C22.4357 16.7918 22.7777 16.7791 25.6611 16.7791C28.5489 16.7791 28.8908 16.7918 30.0266 16.8424C31.0821 16.8889 31.652 17.0662 32.032 17.214C32.5005 17.387 32.927 17.6614 33.2731 18.0202C33.632 18.3707 33.9064 18.7929 34.0796 19.2616C34.2273 19.6415 34.4046 20.2156 34.4511 21.267C34.5018 22.4069 34.5145 22.7487 34.5145 25.6323C34.5145 28.5159 34.5018 28.8536 34.4511 29.9935Z" fill="#DD1814" />
                                        <path d="M25.6543 20.0715C22.5893 20.0715 20.1025 22.5581 20.1025 25.6233C20.1025 28.6884 22.5893 31.175 25.6543 31.175C28.7194 31.175 31.206 28.6884 31.206 25.6233C31.206 22.5581 28.7194 20.0715 25.6543 20.0715ZM25.6543 29.2246C23.6659 29.2246 22.053 27.6118 22.053 25.6233C22.053 23.6347 23.6659 22.022 25.6543 22.022C27.6428 22.022 29.2556 23.6347 29.2556 25.6233C29.2556 27.6118 27.6428 29.2246 25.6543 29.2246Z" fill="#DD1814" />
                                        <path d="M32.7222 19.8522C32.7222 20.568 32.1419 21.1483 31.426 21.1483C30.7102 21.1483 30.1299 20.568 30.1299 19.8522C30.1299 19.1363 30.7102 18.5562 31.426 18.5562C32.1419 18.5562 32.7222 19.1363 32.7222 19.8522Z" fill="#DD1814" />
                                    </svg>
                                </div>
                                <!-- <div @click="goTo('https://www.youtube.com/')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.7156 24.4729C36.7156 23.9881 36.6348 23.4225 36.6348 22.776C36.554 22.1295 36.4732 21.4831 36.3924 20.9174C36.2308 20.2709 35.9884 19.7861 35.5035 19.3821C35.0995 18.978 34.5338 18.7356 33.9682 18.6548C32.1096 18.4123 29.3621 18.3315 25.6449 18.3315C21.9278 18.3315 19.0995 18.4123 17.3217 18.6548C16.756 18.7356 16.1904 18.978 15.7863 19.3821C15.3823 19.7861 15.0591 20.2709 14.8974 20.9174C14.7358 21.4831 14.655 22.0487 14.655 22.776C14.5742 23.4225 14.5742 23.9881 14.5742 24.4729C14.5742 24.9578 14.5742 25.5235 14.5742 26.3315C14.5742 27.1396 14.5742 27.7861 14.5742 28.1901C14.5742 28.675 14.655 29.2406 14.655 29.8871C14.7358 30.5336 14.8166 31.18 14.8974 31.7457C15.0591 32.3921 15.3015 32.877 15.7863 33.281C16.1904 33.6851 16.756 33.9275 17.3217 34.0083C19.1803 34.2507 21.9278 34.3315 25.6449 34.3315C29.3621 34.3315 32.1904 34.2507 33.9682 34.0083C34.5338 33.9275 35.0995 33.6851 35.5035 33.281C35.9075 32.877 36.2308 32.3921 36.3924 31.7457C36.554 31.18 36.6348 30.6144 36.6348 29.8871C36.7156 29.2406 36.7156 28.675 36.7156 28.1901C36.7156 27.7053 36.7156 27.1396 36.7156 26.3315C36.7156 25.5235 36.7156 24.877 36.7156 24.4729ZM29.9278 26.978L23.5439 30.9376C23.4631 31.0184 23.3015 31.0992 23.1399 31.0992C22.9783 31.0992 22.8975 31.0992 22.7358 31.0184C22.4934 30.8568 22.3318 30.6144 22.3318 30.2911V22.2911C22.3318 21.9679 22.4934 21.7255 22.7358 21.5639C22.9783 21.4023 23.3015 21.4023 23.5439 21.5639L29.9278 25.5235C30.1702 25.6851 30.3318 25.9275 30.3318 26.1699C30.3318 26.4123 30.1702 26.8164 29.9278 26.978Z"
                                            fill="#000000" />
                                    </svg>
                                </div> -->
                            </div>


                        </div>
                    </div>

                </div>
            </div>
            <otp :showPopup="showOtpPopup" :smsTimer="smsTimer" :errorSms="otpErrorSms" @resend="resendSms" @verifyCode="submitAnswersWithCode"
                @closePopup="showOtpPopup = false" :success="otpSuccess" :errorMessage="otpError"
                :loading="otpVerifying" />
        </div>
        <div class="d-none d-lg-block d-xl-block d-xxl-block" v-else>
            <div class="main-container">
                <div class="first-container">
                    <div class="first-block">
                         <img src="../assets/img/park-live-first-logo.svg" alt="logo" class="jameson-logo" />
                        <!-- <h1 class="hero-title">
                            ABSOLUT<span class="symbol-reg">®</span> TABASCO<span class="symbol-tm">™</span>
                        </h1> -->
                        <h2 class="hero-subtitle">
                            CHILI PEPPER FLAVORED VODKA
                        </h2>
                        <p class="hero-description">
                            Коллаборация двух уникальных брендов.
                        </p>

                        <div class="hero-buttons-row">
                            <!-- <button @click="scrollToForm" class="btn-primary-cta">
                                ПОПРОБОВАТЬ НА PARK LIVE
                            </button> -->
                            <button @click="scrollToRecipe" class="btn-secondary-cta">
                                РЕЦЕПТЫ <span class="arrow-icon">→</span>
                            </button>
                        </div>
                    </div>

                    <div class="second-block">
                        <div class="product-image-container">
                            <div class="lava-glow"></div>
                            <!-- Место для вставки изображения бутылки Absolut Tabasco -->
                            <!-- <img src="../assets/img/absolut-second-block-img.png" alt="Absolut Tabasco" class="product-img-placeholder" /> -->
                        </div>

                        <!-- Если таймер еще идет -->
                        <!-- <div v-if="!isFinished" class="countdown-wrapper mt-5">
                            <div class="countdown-item">
                                <span class="countdown-number">{{ padNumber(days) }}</span>
                                <span class="countdown-label">ДНЕЙ</span>
                            </div>
                            <div class="countdown-item">
                                <span class="countdown-number">{{ padNumber(hours) }}</span>
                                <span class="countdown-label">ЧАСОВ</span>
                            </div>
                            <div class="countdown-item">
                                <span class="countdown-number">{{ padNumber(minutes) }}</span>
                                <span class="countdown-label">МИНУТ</span>
                            </div>
                            <div class="countdown-item">
                                <span class="countdown-number">{{ padNumber(seconds) }}</span>
                                <span class="countdown-label">СЕКУНД</span>
                            </div>
                        </div>

                        <div v-else class="finished-message mt-5">
                            <p>Уже здесь</p>
                            <a href="#" class="finished-link">Перейти по ссылке</a>
                        </div> -->
                        <!-- <div class="promo-text-container mt-5">
                            <p>
                                Среди всех, кто оставит данные до 13 августа 23:59,<br>
                                определим 5 победителей подарочного набора Absolut. 
                                <a href="#" class="promo-link" @click.prevent="openPopup('rules')">Полные правила розыгрыша</a>
                            </p>
                        </div> -->
                    </div>
                </div>

                <div class="second-container">
                    <div class="second-content-wrapper">
                        <!-- Левая колонка: История коллаборации и характеристики -->
                        <div class="second-left-block">
                            <p class="eyebrow-text">История коллаборации</p>
                            <h2 class="second-title">
                                КОГДА<br>
                                ВСТРЕЧАЮТСЯ<br>
                                ДВЕ ИКОНЫ
                            </h2>
                            <div class="second-description">
                                <p>
                                Absolut — водка, которая с 1879 года делается в шведской деревне Охус из озимой пшеницы одного региона. Tabasco® — соус, который семья Макайленни производит на острове Эйвери-Айленд с 1868 года.                                </p>
                                <p>
                                Absolut Tabasco — первая коллаборация двух легенд: премиум водка с характером настоящего перечного соуса. Созданa для одного — зажечь ваши коктейли.                                </p>
                            </div>

                            <!-- Сетка характеристик (2x2 Matrix) -->
                            <div class="features-grid">
                                <div class="feature-item border-bottom border-right">
                                    <span class="feature-value">38%</span>
                                    <span class="feature-label">Крепость</span>
                                </div>
                                <div class="feature-item border-bottom">
                                    <span class="feature-value">0 г</span>
                                    <span class="feature-label">Сахара</span>
                                </div>
                                <div class="feature-item border-right">
                                    <span class="feature-value">100%</span>
                                    <span class="feature-label">Настоящий Tabasco®</span>
                                </div>
                                <div class="feature-item">
                                    <span class="feature-value">GLUTEN</span>
                                    <span class="feature-label">Free</span>
                                </div>
                            </div>
                        </div>

                        <!-- Правая колонка: Презентация продукта, эффекты, перцы и сноска -->
                        <div class="second-right-block">
                            <div class="product-presentation">
                                <div class="red-radial-glow"></div>
                                <div class="smoke-flame-effect"></div>

                                <!-- Место для вставки изображения бутылки Absolut Tabasco крупным планом -->
                                <img src="../assets/img/park-live-second-block-img.png" alt="Absolut Tabasco Bottle Close-Up" class="bottle-detail-img" />

                                <!-- Место для вставки стручков красного перца чили и семян у основания -->
                                <!-- <div class="chili-peppers-container">
                                    <img src="../assets/img/absolut-second-block-img.png" alt="Red Chili Peppers and Seeds" class="chili-img" />
                                </div> -->
                            </div>

                            <!-- Сноска (Legal text) -->
                            <p class="legal-footnote">
                                ENJOY RESPONSIBLY. TABASCO AND THE DIAMOND LOGO ARE REGISTERED TRADEMARKS OF MCILHENNY COMPANY.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Блок 3: Секция рецептов -->
                <div class="recipes-container"  ref="recipeSection" id="recipes-container">
                    <div class="recipes-content-wrapper">
                        <!-- Шапка секции -->
                        <div class="recipes-header">
                            <p class="recipes-eyebrow">Рецепты</p>
                            <h2 class="recipes-title">ДВА ФИРМЕННЫХ КОКТЕЙЛЯ</h2>
                            <p class="recipes-subtitle">
                            Рецепты разработаны нашими опытными бартендерами.Открой карточку - внутри пошаговый рецепт!                            </p>
                        </div>

                        <!-- 2 рецепта без карусели на десктопе -->
                        <div class="recipes-grid-desktop">
                            <div v-for="recipe in recipes" :key="recipe.id" class="recipe-card-slide-desktop">
                                <div class="recipe-card">
                                    <div class="recipe-card-bg">
                                        <img :src="recipe.image" :alt="recipe.title" class="recipe-card-img" />
                                        <div class="recipe-card-overlay"></div>
                                    </div>
                                    <div class="recipe-card-body">
                                        <h3 class="recipe-card-title">{{ recipe.title }}</h3>
                                        <p class="recipe-card-subtitle">{{ recipe.subtitle }}</p>
                                        <button @click="openRecipeModal(recipe)" class="btn-recipe-view">
                                            Смотреть рецепт <span class="arrow-icon">→</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Блок 4 (Десктоп): Регистрация на Park Live (скрыт, так как мероприятие прошло) -->
                <!-- <div class="third-container" ref="formSection" id="registration-form">
                    <div class="reg-content-wrapper">
                        <div class="reg-left-block">
                            <div class="reg-badge-pill">
                                Розыгрыш открыт до 20 августа, 20:00
                            </div>

                            <p class="reg-eyebrow">PARK LIVE • АЛМАТЫ • 21–23 АВГУСТА</p>

                            <h2 class="reg-title">
                                ПОПРОБУЙ ПЕРВЫМ —<br>
                                HA PARK LIVE
                            </h2>

                            <p class="reg-paragraph">
                                Зона Absolut Tabasco - это бар с крутыми коктейлями и активностями от бренда.                            
                            </p>

                            <p class="reg-paragraph">
                                Разыгрываем 2 абонемента на 3 дня в одни руки среди всех, кто заполнит анкету для участия.  
                            </p>
                            <p class="reg-paragraph">
                            <a @click="openPopup('rules')" style="text-decoration: underline;">Ознакомиться с полными правилами активностями</a>                            
                        </p>
                        </div>

                        <div class="reg-right-block">
                            <div class="form-card-container">
                                <h3 class="form-card-title">ХОЧУ НА PARK LIVE</h3>
                                <p class="form-card-subtitle">
                                    Заполни форму - получи возможность стать обладетелем абонементов на 3 дня. 
                                 </p>

                                <div v-if="isLoadingForm" class="form-loading">
                                    <v-progress-circular indeterminate size="64" color="#FFFFFF" />
                                </div>

                                <div v-else-if="formError" class="form-error">
                                    <p class="form-error-text">Ошибка загрузки формы. Попробуйте позже.</p>
                                    <button class="btn-form-outline mt-6 mb-6" @click="getFormFields">
                                        Повторить попытку
                                    </button>
                                </div>

                                <div v-else class="form-main-block">
                                    <div v-for="question in normalQuestions" :key="question.id" class="form-group-item">
                                        <label class="form-input-label">{{ question.name }}</label>
                                        <div class="input-wrapper-card">
                                            <input 
                                                v-if="[1, 2, 7, 10].includes(question.type)" 
                                                class="input-body-card"
                                                v-model="formData[question.id]" 
                                                :placeholder="getPlaceholder(question)"
                                                @blur="markTouched(question)" 
                                                @input="validateField(question)" 
                                            />
                                            <input 
                                                v-else-if="question.type === 4" 
                                                class="input-body-card"
                                                v-model="formData[question.id]" 
                                                v-mask="'+7(###) ###-##-##'"
                                                placeholder="+7 (7__) ___-__-__" 
                                                @blur="markTouched(question)"
                                                @focus="onPhoneFocus(question)" 
                                                @input="onPhoneInput(question)" 
                                            />
                                            <v-select 
                                                v-else-if="[5, 9, 6].includes(question.type)" 
                                                v-model="formData[question.id]"
                                                :items="question.answers" 
                                                item-text="name" 
                                                item-value="id" 
                                                dense 
                                                outlined
                                                hide-details 
                                                :placeholder="getPlaceholder(question)" 
                                                class="card-select"
                                            >
                                                <template v-slot:selection="{ item }">
                                                    <div class="select-input" style="white-space: normal; word-break: break-word;">
                                                        {{ item.name }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="error-message">
                                                <span v-show="errors[question.id]">{{ errors[question.id] }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="checkboxes-wrapper mt-4">
                                        <div v-for="question in filteredQuestions" :key="question.id" class="checkbox-container-card">
                                            <div class="checkbox-content-card">
                                                <input 
                                                    class="custom-checkbox-card" 
                                                    type="checkbox" 
                                                    v-model="formData[question.id]"
                                                    :id="'card_' + question.id" 
                                                    @change="markTouched(question)"
                                                    @input="validateField(question)" 
                                                />
                                                <label class="checkbox-label-card" :for="'card_' + question.id">
                                                    <template v-if="question.number === 7">
                                                        Я даю согласие на
                                                        <a class="legal-link" @click.stop.prevent="openPopup('offer')">
                                                            сбор и обработку персональных данных
                                                        </a>
                                                    </template>
                                                    <template v-else>
                                                        {{ question.name }}
                                                    </template>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="btn-submit-container mt-6">
                                        <button 
                                            @click="confirmRegistration"
                                            class="btn-form-outline"
                                            :disabled="isSendSms"
                                        >
                                            {{ isSendSms ? "Отправка..." : "УЧАСТВОВАТЬ" }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- Блок 5: Покупка и Таймер (Xo.kz) -->
                <div class="fifth-container">
                    <div class="fifth-content-wrapper">
                        <!-- Надзаголовок -->
                        <p class="fifth-eyebrow">ГДЕ КУПИТЬ</p>

                        <!-- Заголовок H2 -->
                        <h2 class="fifth-title">УЖЕ В ПРОДАЖЕ</h2>

                        <!-- Описание -->
                        <p class="fifth-subtitle">
                            Absolut Tabasco 0.7 л - на Xo.kz с доставкой по Алматы и Астане. Не забудь применить промокод из письма.
                        </p>

                        <!-- Таймер обратного отсчета (Состояние 1: пока временно до 24.08, скрывается при автопереключении) -->
                        <div v-if="!isBuyAvailable" class="buy-countdown-grid">
                            <div class="buy-countdown-block">
                                <span class="buy-countdown-number">{{ padNumber(buyDays) }}</span>
                                <span class="buy-countdown-label">ДНЕЙ</span>
                            </div>
                            <div class="buy-countdown-block">
                                <span class="buy-countdown-number">{{ padNumber(buyHours) }}</span>
                                <span class="buy-countdown-label">ЧАСОВ</span>
                            </div>
                            <div class="buy-countdown-block">
                                <span class="buy-countdown-number">{{ padNumber(buyMinutes) }}</span>
                                <span class="buy-countdown-label">МИНУТ</span>
                            </div>
                            <div class="buy-countdown-block">
                                <span class="buy-countdown-number">{{ padNumber(buySeconds) }}</span>
                                <span class="buy-countdown-label">СЕКУНД</span>
                            </div>
                        </div>

                        <!-- Элементы управления (Кнопка в 2 состояниях) -->
                        <div class="buy-action-container">
                            <!-- Состояние 1: Кнопка заблокирована (До 24.08 00:00) -->
                            <button v-if="!isBuyAvailable" class="btn-buy-disabled" disabled>
                                <svg class="lock-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span>КУПИТЬ — ОТКРОЕТСЯ 24 АВГУСТА</span>
                            </button>

                            <!-- Состояние 2: Кнопка активна (С 24.08 00:00 - Автопереключение + UTM) -->
                            <button v-else @click="goToStore" class="btn-buy-active">
                                <span>КУПИТЬ НА XO.KZ</span>
                                <span class="arrow-icon">→</span>
                            </button>
                        </div>

                        <!-- Инфо-баннер (Promo Pill) -->
                        <div class="promo-pill-banner">
                            <svg class="ticket-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 5V19M4 10C4 10 6 10 6 12C6 14 4 14 4 14V17C4 18.1046 4.89543 19 6 19H18C19.1046 19 20 18.1046 20 17V14C20 14 18 14 18 12C18 10 20 10 20 10V7C20 5.89543 19.1046 5 18 5H6C4.89543 5 4 5.89543 4 7V10Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="promo-pill-text">Промокод <strong>-15%</strong> — всем участникам розыгрыша</span>
                        </div>
                    </div>
                </div>

                <div class="main-container-footer">


                    <div class="footer-container">
                        <div class="politics-container">
                            <div class="mb-4">
                                <img src="../assets/img/park-live-footer-logo.svg" alt="" class="jameson-logo-footer" />
                            </div>
                            <div class="d-flex">
                                <div class="footer-first-block">
                                    <p class="link-text pb-5">{{ config.footer.warningText }}</p>
                                    <a class="link-text" style="text-decoration: underline;"
                                        :href="config.footer.policyLink.href" target="_blank">
                                        {{ config.footer.policyLink.text }}
                                    </a>
                                </div>
                                <div class="footer-second-block">
                                    <p v-for="(item, index) in config.footer.menuLinks" :key="index"
                                        class="footer-main-text">
                                        <a class="footer-main-text" @click="openPopup(item.href)">{{ item.text
                                            }}</a>
                                    </p>
                                </div>
                                <div class="footer-third-block">
                                    <p
                                        class="link-text">
                                        21+. Чрезмерное употребление алкоголя вредит вашему здоровью
                                    </p>
                                    <p
                                        class="link-text mt-2">
                                        Розыгрыш проводится по <a style="text-decoration: underline;" @click="openPopup('rules')">официальным правилам</a>. Организатор — Pernod Ricard Kazakhstan. Победителей объявим 20 августа в соцсетях бренда.
                                    </p>
                                </div>
                            </div>
                            <!-- <button @click="openPopup('policy')">Политика конфиденциальности</button>
                            <button @click="openPopup('offer')">Оферта</button>
                            <button @click="openPopup('rules')">Правила</button> -->
                        </div>
                        <div class="social-container">
                            <div class="footer-j-logo">
                                <!-- <img :src="config.footer.logo" class="j-logo-footer" alt="j-logo">
                                    <img src="../assets/img/j-invicible.png" alt="logo" class="j-logo-footer" /> -->
                            </div>
                            <div class="social-icons-container">
                                <!-- <div class="" @click="goTo('https://www.facebook.com/ChivasRegalKazakhstan')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#F2E4B5" />
                                        <path
                                            d="M37.0742 18.1049C37.0742 16.2331 35.4227 14.5815 33.5509 14.5815H19.3475C17.4758 14.5815 15.8242 16.2331 15.8242 18.1049V32.3082C15.8242 34.18 17.4758 35.8315 19.3475 35.8315H26.5043V27.794H23.8618V24.2707H26.5043V22.8393C26.5043 20.417 28.2659 18.3251 30.468 18.3251H33.3307V21.8484H30.468C30.1377 21.8484 29.8074 22.1787 29.8074 22.8393V24.2707H33.3307V27.794H29.8074V35.8315H33.5509C35.4227 35.8315 37.0742 34.18 37.0742 32.3082V18.1049Z"
                                            fill="#000000" />
                                    </svg>
                                </div> -->
                                <div @click="goTo('https://www.instagram.com/weareabsolut')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="#DD1814"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.3973 21.1698C36.3467 20.0215 36.161 19.232 35.895 18.548C35.6206 17.8218 35.1984 17.1717 34.6452 16.6313C34.1048 16.0825 33.4504 15.656 32.7327 15.3859C32.0447 15.1199 31.2593 14.9342 30.111 14.8835C28.9541 14.8286 28.5869 14.8159 25.6527 14.8159C22.7185 14.8159 22.3512 14.8286 21.1986 14.8792C20.0503 14.9299 19.2609 15.1157 18.5769 15.3816C17.8507 15.656 17.2006 16.0782 16.6601 16.6313C16.1113 17.1717 15.685 17.8261 15.4147 18.5439C15.1487 19.232 14.963 20.0172 14.9123 21.1655C14.8574 22.3224 14.8447 22.6897 14.8447 25.6239C14.8447 28.5581 14.8574 28.9253 14.9081 30.0779C14.9587 31.2263 15.1445 32.0157 15.4106 32.6998C15.685 33.4259 16.1113 34.076 16.6601 34.6164C17.2006 35.1653 17.8549 35.5918 18.5727 35.8619C19.2609 36.1279 20.046 36.3136 21.1945 36.3642C22.3469 36.415 22.7144 36.4276 25.6486 36.4276C28.5828 36.4276 28.95 36.415 30.1026 36.3642C31.2509 36.3136 32.0404 36.1279 32.7243 35.8619C34.1767 35.3003 35.325 34.152 35.8866 32.6998C36.1524 32.0116 36.3383 31.2263 36.3889 30.0779C36.4395 28.9253 36.4522 28.5581 36.4522 25.6239C36.4522 22.6897 36.4479 22.3224 36.3973 21.1698ZM34.4511 29.9935C34.4046 31.049 34.2273 31.6189 34.0796 31.9989C33.7164 32.9404 32.9692 33.6876 32.0277 34.0508C31.6477 34.1985 31.0736 34.3758 30.0223 34.4222C28.8824 34.473 28.5405 34.4855 25.657 34.4855C22.7734 34.4855 22.4272 34.473 21.2915 34.4222C20.236 34.3758 19.6661 34.1985 19.2861 34.0508C18.8176 33.8776 18.3911 33.6032 18.0449 33.2443C17.6861 32.8939 17.4116 32.4717 17.2385 32.0032C17.0907 31.6232 16.9134 31.049 16.8671 29.9978C16.8163 28.8579 16.8038 28.5159 16.8038 25.6323C16.8038 22.7487 16.8163 22.4026 16.8671 21.267C16.9134 20.2115 17.0907 19.6415 17.2385 19.2616C17.4116 18.7929 17.6861 18.3666 18.0492 18.0202C18.3995 17.6614 18.8217 17.387 19.2904 17.214C19.6703 17.0662 20.2446 16.8889 21.2958 16.8424C22.4357 16.7918 22.7777 16.7791 25.6611 16.7791C28.5489 16.7791 28.8908 16.7918 30.0266 16.8424C31.0821 16.8889 31.652 17.0662 32.032 17.214C32.5005 17.387 32.927 17.6614 33.2731 18.0202C33.632 18.3707 33.9064 18.7929 34.0796 19.2616C34.2273 19.6415 34.4046 20.2156 34.4511 21.267C34.5018 22.4069 34.5145 22.7487 34.5145 25.6323C34.5145 28.5159 34.5018 28.8536 34.4511 29.9935Z"
                                            fill="#DD1814" />
                                        <path
                                            d="M25.6543 20.0715C22.5893 20.0715 20.1025 22.5581 20.1025 25.6233C20.1025 28.6884 22.5893 31.175 25.6543 31.175C28.7194 31.175 31.206 28.6884 31.206 25.6233C31.206 22.5581 28.7194 20.0715 25.6543 20.0715ZM25.6543 29.2246C23.6659 29.2246 22.053 27.6118 22.053 25.6233C22.053 23.6347 23.6659 22.022 25.6543 22.022C27.6428 22.022 29.2556 23.6347 29.2556 25.6233C29.2556 27.6118 27.6428 29.2246 25.6543 29.2246Z"
                                            fill="#DD1814" />
                                        <path
                                            d="M32.7222 19.8522C32.7222 20.568 32.1419 21.1483 31.426 21.1483C30.7102 21.1483 30.1299 20.568 30.1299 19.8522C30.1299 19.1363 30.7102 18.5562 31.426 18.5562C32.1419 18.5562 32.7222 19.1363 32.7222 19.8522Z"
                                            fill="#DD1814" />
                                    </svg>
                                </div>
                                <!-- <div @click="goTo('https://www.youtube.com/')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.7156 24.4729C36.7156 23.9881 36.6348 23.4225 36.6348 22.776C36.554 22.1295 36.4732 21.4831 36.3924 20.9174C36.2308 20.2709 35.9884 19.7861 35.5035 19.3821C35.0995 18.978 34.5338 18.7356 33.9682 18.6548C32.1096 18.4123 29.3621 18.3315 25.6449 18.3315C21.9278 18.3315 19.0995 18.4123 17.3217 18.6548C16.756 18.7356 16.1904 18.978 15.7863 19.3821C15.3823 19.7861 15.0591 20.2709 14.8974 20.9174C14.7358 21.4831 14.655 22.0487 14.655 22.776C14.5742 23.4225 14.5742 23.9881 14.5742 24.4729C14.5742 24.9578 14.5742 25.5235 14.5742 26.3315C14.5742 27.1396 14.5742 27.7861 14.5742 28.1901C14.5742 28.675 14.655 29.2406 14.655 29.8871C14.7358 30.5336 14.8166 31.18 14.8974 31.7457C15.0591 32.3921 15.3015 32.877 15.7863 33.281C16.1904 33.6851 16.756 33.9275 17.3217 34.0083C19.1803 34.2507 21.9278 34.3315 25.6449 34.3315C29.3621 34.3315 32.1904 34.2507 33.9682 34.0083C34.5338 33.9275 35.0995 33.6851 35.5035 33.281C35.9075 32.877 36.2308 32.3921 36.3924 31.7457C36.554 31.18 36.6348 30.6144 36.6348 29.8871C36.7156 29.2406 36.7156 28.675 36.7156 28.1901C36.7156 27.7053 36.7156 27.1396 36.7156 26.3315C36.7156 25.5235 36.7156 24.877 36.7156 24.4729ZM29.9278 26.978L23.5439 30.9376C23.4631 31.0184 23.3015 31.0992 23.1399 31.0992C22.9783 31.0992 22.8975 31.0992 22.7358 31.0184C22.4934 30.8568 22.3318 30.6144 22.3318 30.2911V22.2911C22.3318 21.9679 22.4934 21.7255 22.7358 21.5639C22.9783 21.4023 23.3015 21.4023 23.5439 21.5639L29.9278 25.5235C30.1702 25.6851 30.3318 25.9275 30.3318 26.1699C30.3318 26.4123 30.1702 26.8164 29.9278 26.978Z"
                                            fill="#000000" />
                                    </svg>
                                </div> -->
                            </div>


                        </div>
                    </div>

                </div>
                <otp :showPopup="showOtpPopup" :errorSms="otpErrorSms" :smsTimer="smsTimer" @resend="resendSms"
                    @verifyCode="submitAnswersWithCode" @closePopup="showOtpPopup = false" :success="otpSuccess"
                    :errorMessage="otpError" :loading="otpVerifying" />

            </div>


        </div>
        <ConfirmAge1 v-if="showConfirm" @confirmed="onConfirmed" />
        <transition name="popup">
            <div v-if="isPopupOpen" class="popup-overlay" @click.self="closePopup">
                <div class="popup-content">
                    <div class="popup-header">
                        <span class="header-text">{{ popupTexts[currentPopup].title }}</span>
                        <span class="popup-close-1" @click="closePopup"><svg width="21" height="21" viewBox="0 0 40 40"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1.07373 33.4784C-0.348236 34.8712 -0.377256 37.4247 1.10275 38.9046C2.58275 40.3845 5.13648 40.3264 6.52942 38.9336L19.9945 25.4697L33.4597 38.9046C34.9106 40.3555 37.4063 40.3845 38.8863 38.8756C40.3663 37.3957 40.3663 34.9003 38.9154 33.4494L25.4793 20.0145L38.9154 6.5506C40.3663 5.09975 40.3663 2.60428 38.8863 1.12441C37.4063 -0.384476 34.9106 -0.355459 33.4597 1.09539L19.9945 14.5303L6.52942 1.06638C5.13648 -0.326442 2.58275 -0.384476 1.10275 1.09539C-0.377256 2.57526 -0.348236 5.12876 1.07373 6.5506L14.5388 20.0145L1.07373 33.4784Z"
                                    fill="white" />
                            </svg></span>
                    </div>
                    <div class="popup-text-1" v-html="popupTexts[currentPopup].content"></div>
                </div>
            </div>
        </transition>

        <!-- Модальное окно рецепта -->
        <transition name="popup">
            <div v-if="showRecipeModal && selectedRecipe" class="recipe-modal-overlay" @click.self="closeRecipeModal">
                <div class="recipe-modal-content">
                    <!-- Иконка закрытия -->
                    <button class="recipe-modal-close" @click="closeRecipeModal" aria-label="Закрыть">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>

                    <!-- Шапка модалки -->
                    <div class="recipe-modal-header">
                        <h2 class="recipe-modal-title">{{ selectedRecipe.title }}</h2>
                        <p class="recipe-modal-tagline">{{ selectedRecipe.tagline }}</p>
                    </div>

                    <!-- Информационный блок: Две колонки -->
                    <div class="recipe-modal-info">
                        <!-- Левая колонка: СОСТАВ -->
                        <div class="recipe-info-column">
                            <div class="recipe-section-title-wrap">
                                <h3 class="recipe-section-title">СОСТАВ</h3>
                                <div class="recipe-section-line"></div>
                            </div>
                            <div class="ingredients-list">
                                <div v-for="(ing, idx) in selectedRecipe.ingredients" :key="idx" class="ingredient-row">
                                    <span class="ing-name">{{ ing.name }}</span>
                                    <span class="ing-amount">{{ ing.amount }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Правая колонка: ШАГИ ПРИГОТОВЛЕНИЯ -->
                        <div class="recipe-info-column">
                            <div class="recipe-section-title-wrap">
                                <h3 class="recipe-section-title">ШАГИ ПРИГОТОВЛЕНИЯ</h3>
                                <div class="recipe-section-line"></div>
                            </div>
                            <div class="steps-list">
                                <div v-for="(step, idx) in selectedRecipe.steps" :key="idx" class="step-row">
                                    <span class="step-number">{{ idx + 1 }}</span>
                                    <p class="step-text">{{ step }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </transition>

        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    Закрыть
                </div>
            </template>
        </v-snackbar>
    </div>

</template>


<style scoped>
.with-padding {
    display: block;
    /* чтобы padding сработал корректно */
    margin-top: 25px;
}

.background-image-mobile-topright {
    position: absolute;
    top: -1px;
    right: 0;
    height: auto;
    /* width: 20%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-topleft {
    position: absolute;
    top: -1px;
    left: 0;
    height: auto;
    /* width: 20%; */
    object-fit: cover;
    z-index: 1;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
    padding: 4px 8px;
    color: var(--color-white);
    font-size: var(--font-size-xs);
    font-family: var(--font-family) !important;
    font-weight: 400 !important;
}

.third-container ::v-deep .v-select input::placeholder {
    color: var(--color-white) !important;
    font-weight: 400 !important;
    font-size: var(--font-size-md);
    font-family: var(--font-family) !important;
}

.third-container ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0 12px;
    width: 506px !important;
    min-height: 48px;
}

.third-container ::v-deep .v-list-item--dense .v-list-item__title {
    font-size: 20px !important;
}

input:focus {
    outline: 1px solid #1976d2;
    /* синяя обводка */
    /* или */
    box-shadow: 0 0 5px #1976d2;
}

.third-container ::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
    color: var(--color-white)  !important;
    border-radius: 10.64px;
}

.third-container ::v-deep .v-select.v-input--dense .v-select__selection--comma {
    margin: 0;
    font-size: 20px;
}

.third-container ::v-deep .v-input__slot {
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    min-height: inherit;
    position: relative;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    transition-property: height, min-height;
    /* width: 461px; */
}

.third-container ::v-deep .v-input {
    align-items: flex-start;
    display: flex;
    flex: none;
    font-size: 16px;
    letter-spacing: normal;
    max-width: 100%;
    text-align: left;
    /* height: 48px; */
}

.popup-header {
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.popup-content {
    background-color: var(--color-primary);
    background-size: cover;
    background-position: center;
    padding: 20px;
    width: 100%;
    max-width: 1150px;
    border-radius: 10px;
    /* max-height: 897px; */
    height: 100%;
    max-height: 80vh;
    /* ограничение всей области */
    display: flex;
    flex-direction: column;

}

:deep(.chivas-link) {
    color: #141097;
    font-weight: bold;
    text-decoration: underline;
    transition: color 0.2s;
}

:deep(.chivas-link:hover) {
    color: #FFFFFF;
    text-decoration: underline;
}

.condition-container {
    border-top: 2px solid #141097;
    /* border-bottom: 2px solid #141097; */
}

.second-second-block .condition-container:last-child {
    border-bottom: 2px solid #141097;
}

/* .second-second-block .condition-container:nth-child(-n+3) {
    border-bottom: none;
} */


.condition-text {
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    line-height: 1.1;
    margin-left: 39.4px;
    font-family: "MontserratBold";
}

.condition-text span {
    font-weight: 700;
    font-size: 32px;
    color: #141097;
    margin-bottom: 0px;
    font-family: "MontserratBold";
    text-decoration: none;
}

.second-second-block-mobile .condition-container:nth-child(-n+3) {
    border-bottom: none;
}
.second-block {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    z-index: 2;
}

.countdown-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 100%;
    margin: 20px auto 0;
    box-sizing: border-box;
}

.countdown-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 109px;
    height: 132px;
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    color: #ffffff;
    box-sizing: border-box;
    flex: 0 0 auto;
}

.countdown-number {
    font-size: 64px;
    font-weight: 900;
    line-height: 1;
    margin-bottom: 4px;
    font-family: var(--font-family-black);
    color: var(--color-white);
}

.countdown-label {
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 700;
    font-family: var(--font-family-medium);
    color: rgba(255, 255, 255, 0.9);
}

/* Mobile Figma Specs (iPhone 13 Pro 390px: 60px x 73px) */
@media screen and (max-width: 768px) {
    .countdown-wrapper {
        gap: clamp(8px, 2.5vw, 12px);
    }

    .countdown-item {
        width: clamp(52px, 15.38vw, 60px);
        height: clamp(63px, 18.71vw, 73px);
        border-radius: 8px;
    }

    .countdown-number {
        font-size: clamp(26px, 8.2vw, 32px);
        margin-bottom: 2px;
    }

    .countdown-label {
        font-size: clamp(9px, 2.5vw, 10px);
        letter-spacing: 0.5px;
    }
}
.btn-form-submit-1 {
    border-radius: 10px;
    padding: 11px 42px;
    /* width: 226px; */
    height: 59px;
    background: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 20px;
    color: var(--color-primary-dark);
}
/* Стили для состояния "Уже здесь" */
.finished-message {
    text-align: center;
    color: #ffffff;
}

.finished-message p {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 15px;
    text-transform: uppercase;
}

.finished-link {
    display: inline-block;
    padding: 10px 25px;
    background-color: #ffffff;
    color: #cc0000; /* Подбери точный красный цвет из макета */
    text-decoration: none;
    font-weight: bold;
    border-radius: 4px;
    transition: background-color 0.3s ease;
}

.finished-link:hover {
    background-color: #f0f0f0;
}
.error-message {
    color: red;
    font-weight: 300;
    font-size: 14px;
    font-family: "MontserratRegular";
    min-height: 18px;
}

.form-main-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    max-width: 666px;


}

.form-loading {
    display: flex;
    justify-content: center;
    align-items: center;
}

.form-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.form-error-text {
    font-weight: 400;
    font-size: 16px;
    color: #ad0202;
    margin-bottom: 0px;
    font-family: "MontserratRegular";
}

.registration-body-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border-radius: 20px; */
    padding: 0px 33.33px 0px;
    /* max-width: 1033px;
    min-width: 320px; */
    height: 100%;
    /* background: #f2e4b5; */
    margin: auto;
}



.btn-form-submit,
.btn-form-submit-mobile {
    border-radius: 10px;
    padding: 11px 42px;
    height: 59px;
    background: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 20px;
    color: var(--color-primary-light);
    cursor: pointer;
    box-shadow: 0 4px 0 var(--color-primary-dark);

    /* медленный возврат */
    transition: all 0.4s ease;
}

/* При наведении (быстрее, чем возврат) */
.btn-form-submit:hover,
.btn-form-submit-mobile:hover {
    background: var(--color-white);
    transform: translateY(-2px);
    box-shadow: 0 6px 0 #4d4d50;

    /* ускоренный вход */
    transition: all 0.15s ease-out;
}

/* При нажатии */
.btn-form-submit:active,
.btn-form-submit-mobile:active {
    background: var(--color-white);
    transform: translateY(2px);
    box-shadow: 0 2px 0 #585858;
    transition: all 0.1s ease-in;
}

.btn-form-submit {
    border-radius: 10px;
    padding: 11px 42px;
    /* width: 226px; */
    height: 59px;
    background: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 20px;
    color: var(--color-primary-dark);
}

.btn-form-submit-mobile {
    border-radius: 10px;
    padding: 11px 42px;
    /* width: 360px; */
    height: 59px;
    background: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 20px;
    color: var(--color-primary-dark);
}

.position-relative {
    position: relative;
}

.popup-enter-active,
.popup-leave-active {
    animation: fadeIn 0.3s ease-in-out, slideIn 0.3s ease-in-out;
}

.popup-leave-active {
    animation: fadeOut 0.3s ease-in-out, slideOut 0.3s ease-in-out;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}



.popup-container {
    background: var(--color-primary);
    padding: 20px;
    text-align: center;
    position: relative;
    border-radius: 30px;
    width: 594px;
    height: 421px;
}

.popup-close {
    position: absolute;
    top: 25px;
    right: 27px;
    background: none;
    border: none;
    color: #f2e4b5;
    cursor: pointer;
}

.popup-logo {
    width: auto;
    height: auto;
    margin-bottom: 38px;
    margin-top: 10px;
}

.popup-title {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 40px;
    text-transform: uppercase;
    text-align: center;
    color: #f2e4b5;
    margin-bottom: 31px;
}

.popup-text {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 36px;
    text-align: center;
    color: #f2e4b5;
    max-width: 346px;
    width: 100%;
    margin-bottom: 0px;
    line-height: 1.2;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@keyframes slideIn {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slideOut {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(-20px);
        opacity: 0;
    }
}
/* Красит селект стрелку */
::v-deep .theme--light.v-icon {
    color: var(--color-white) !important; 
}

.social-icons-container {
    cursor: pointer;
}

.social-icons-container svg {
    width: 48px;
    height: 48px;
    transition: transform 0.3s ease;
}

.social-icons-container svg:hover {
    transform: scale(1.1);
}

.social-icons-container {
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: center;
}

.j-logo-footer {
    width: 118px;
    height: 155px;
}

.politics-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: auto;
}

.main-container-footer {
    padding-left: clamp(16px, 10vw, 195.74px);
    padding-right: clamp(16px, 9.5vw, 184.11px);
    padding-top: clamp(40px, 6.76vh, 73px);
    padding-bottom: clamp(40px, 7.5vh, 101px);
    background-color: var(--color-primary);

}

.footer-j-logo {
    text-align: center;
}

.social-container {
    display: flex;
    flex-direction: column;
    /* gap: 20px; */
    /* flex-wrap: wrap; */
    justify-content: center;
    /* margin-top: auto; */

    height: 242px;
}

.footer-main-text {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: clamp(16px, 1.5vw, 20px);
    line-height: 175%;
    color: #FFFFFF;
    margin-bottom: 0;
    text-decoration: none;
}

.link-text {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin-bottom: 0px;
}

.footer-first-block {
    max-width: clamp(240px, 21.04vw, 404px);
    margin-right: clamp(20px, 3.13vw, 60px);
}

.footer-third-block {
    max-width: clamp(240px, 21.04vw, 404px);
    margin-left: clamp(20px, 3.13vw, 60px);
}

.footer-container {

    display: flex;
    justify-content: space-between;
    align-items: center;
}

.jameson-logo-footer {
    width: clamp(220px, 12.95vw, 310px);
    /* 268px ≈ 13.95vw на экране 1920px */
    height: clamp(112px, 5.93vh, 64px);
    /* 64px ≈ 5.93vh на экране 1080px */
}

.btn-green {
    border-radius: 10px;
    padding: 11px 42px;
    /* width: 226px; */
    height: 59px;
    background: #141097;
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 20px;
    color: #f2e4b5;
}

.checkbox {
    /* appearance: none; */
    /* убираем стандартный стиль браузера */
    width: 20px;
    height: 20px;
    border: 1px solid #141097;
    background-color: white;
    margin-right: 6px;
}

.checkbox-mobile {
    /* appearance: none; */
    /* убираем стандартный стиль браузера */
    width: 20px;
    height: 20px;
    border: 1px solid #141097;
    background-color: white;
    margin-left: 20px;
}

.checkbox-container {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    flex-direction: column;
}

.checkbox-container label {
    color: white;
    font-family: var(--font-family-bold);
}

.checkbox-container router-link {
    color: white;
}

.btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.input-body {
    border: 1px solid #FFFFFF;
    color: #FFFFFF;
    border-radius: 10px;
    padding: 15px 23px;
    width: 499px;
    height: 59px;
    font-size: var(--font-size-md);
    font-family: var(--font-family-bold);
    background: transparent;
    box-sizing: border-box;
}

.input-body::placeholder {
    color: var(--color-white);
    /* Задайте нужный цвет */
    font-size: var(--font-size-md);
    font-family: var(--font-family-bold);
    opacity: 1;
}

.input-name {
    font-family: "MontserratBold", sans-serif;
    font-weight: 700;
    font-size: 20px;
    color: #FFFFFF;
    flex: 0 0 160px;
    text-align: right;
    margin: 0;
    white-space: nowrap;
    max-width: 499px;
}

.input-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    max-width: 499px;
}

.form-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    /* gap: 20px; */
}

.form-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;
    max-width: 680px;
    margin: 0 auto;
}

.text-title {
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(32px, 4.5vw, 64px);
    text-transform: uppercase;
    text-align: center;
    color: var(--color-white);
    margin-bottom: 0;
    line-height: 1.2;
}
.text-title-main {
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(22px, 3vw, 44px);
    text-transform: uppercase;
    text-align: center;
    color: var(--color-white);
    line-height: 1.2;
    margin-bottom: 30px;
    overflow-wrap: break-word;
    word-break: break-word;
}


.title-container {
    max-width: 1398px;
    /* margin: auto; */
    padding-top: 86px;
    padding-bottom: 52px;
}

.registration-body-container {
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    /* border-radius: 20px; */

    /* max-width: 1033px;
    min-width: 320px; */
    /* height: 100%; */

    /* background: #f2e4b5; */
    margin: auto;
}

.third-container {
    /* background-color: #F2E4B5; */
    position: relative;
    background-image: url('../assets/img/absolut-form-bg.jpg');
    background-size: cover;
    background-position: center;
    /* height: 120vh; */
    /* padding: 142px 183.66px 127.15px 209.54px; */

}

.second-first-block {
    padding-top: 94px;
}

.number {
    color: #141097;
    font-size: 96px;
    font-weight: 400;
    margin-bottom: 0px;
    font-family: "MontserratRegular";
}

.second-block-description span {
    color: #141097;
    font-weight: 700;
    font-size: 32px;
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    line-height: 1.2;
    text-transform: uppercase;
    font-family: "MontserratBold";
}

.second-first-container {
    margin: 0px 183px 0px;
}

.second-block-title {
    color: #141097;
    font-weight: 900;
    font-size: 80px;
    text-transform: uppercase;
    margin-bottom: 0px;
    font-family: "MontserratBlack";

}

.second-second-block {
    padding-bottom: 21.1979166667vw;
    max-width: 1075px;
}

.second-contaier {
    background-image:
        var(--bg-url);
    background-size: cover;
    background-position: center;
    height: 100%;
}

.big-img-first-block {
    max-width: 789.74px;
    max-height: 1046.18px;
    width: 100%;
    object-fit: cover;
    border-radius: 20px;
    /* transform: rotate(-7deg); */
}

.description-first-block {
    color: #141097;
    font-weight: 500;
    /* font-size: 30px; */
    font-size: 1.5625vw;
    line-height: 1.2;
    margin-top: 24px;
    /* max-width: 688px; */
    max-width: 780px;
    font-family: "MontserratMedium";
}

.description-first-block-small {
    font-weight: 500;
    font-size: 15px;
    color: #fff;
    line-height: 1.2;
    margin-top: 24px;
    max-width: 688px;
    font-family: "MontserratMedium";
}

.title-first-block span {
    text-transform: uppercase;
}

.title-first-block {
    color: #FFFFFF;
    font-weight: 900;
    font-size: clamp(50px, 3.8vw, 80px);
    line-height: 1.15;
    margin-top: 124px;
    margin-bottom: 24px;
    font-family: "MontserratBlack";
}

/* ==================== HERO SECTION (DESKTOP BLOCK 1) ==================== */
.first-container {
    background-image: linear-gradient(89.96deg, rgba(0, 0, 0, 0.5) 15.2%, rgba(0, 0, 0, 0) 100%), url('../assets/img/park-live-first-block-bg.jpg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: #0b0b0d;
    min-height: 100vh;
    padding: 80px clamp(24px, 6vw, 120px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 40px;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    overflow: hidden;
}

.first-block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    margin: 0;
    max-width: 650px;
    flex: 1 1 480px;
    z-index: 2;
}
.jameson-logo {
    max-width: 478px;
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}
.hero-title {
    color: var(--color-white);
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(40px, 4.2vw, 76px);
    line-height: 1.05;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    margin: 0 0 16px 0;
}

.hero-title .symbol-reg {
    font-size: 0.45em;
    vertical-align: super;
    font-family: var(--font-family-bold);
    margin-left: 2px;
    margin-right: 6px;
}

.hero-title .symbol-tm {
    font-size: 0.45em;
    vertical-align: super;
    font-family: var(--font-family-bold);
    margin-left: 2px;
}

.hero-subtitle {
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: clamp(20px, 1.8vw, 32px);
    line-height: 1.2;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    margin: 0 0 20px 0;
}

.hero-description {
    color: var(--color-white);
    font-family: var(--font-family);
    font-weight: 400;
    font-size: clamp(16px, 1.3vw, 22px);
    line-height: 1.4;
    margin: 0 0 36px 0;
}

.hero-buttons-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
}

.btn-primary-cta {
    background-color: var(--color-primary-dark);
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 18px;
    padding: 16px 36px;
    border-radius: var(--radius-md);
    border: none;
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    transition: all var(--transition-fast);
    box-shadow: var(--box-shadow-btn);
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.btn-primary-cta:hover {
    background-color: var(--color-primary);
    transform: translateY(-2px);
    box-shadow: var(--box-shadow-btn-hover);
}

.btn-primary-cta:active {
    transform: translateY(1px);
    box-shadow: var(--box-shadow-btn-active);
}

.btn-secondary-cta {
    background-color: transparent;
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 18px;
    padding: 16px 32px;
    border-radius: var(--radius-md);
    border: 1px solid var(--color-white);
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    transition: all var(--transition-fast);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.btn-secondary-cta:hover {
    background-color: rgba(255, 255, 255, 0.15);
    border-color: var(--color-white);
    transform: translateY(-2px);
}

.btn-secondary-cta:active {
    transform: translateY(1px);
    background-color: rgba(255, 255, 255, 0.05);
}

.arrow-icon {
    font-size: 20px;
    transition: transform var(--transition-fast);
}

.btn-secondary-cta:hover .arrow-icon {
    transform: translateX(4px);
}

.product-image-container {
    position: relative;
    width: 100%;
    max-width: 440px;
    min-height: 420px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.lava-glow {
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba(255, 80, 0, 0.75) 0%, rgba(221, 24, 20, 0.45) 45%, rgba(0, 0, 0, 0) 75%);
    filter: blur(45px);
    border-radius: 50%;
    pointer-events: none;
    z-index: 1;
    animation: lavaPulse 4s ease-in-out infinite alternate;
}

@keyframes lavaPulse {
    0% {
        opacity: 0.7;
        transform: translateX(-50%) scale(0.95);
    }
    100% {
        opacity: 1;
        transform: translateX(-50%) scale(1.1);
    }
}

.product-img-placeholder {
    position: relative;
    z-index: 2;
    max-width: 100%;
    max-height: 440px;
    object-fit: contain;
    filter: drop-shadow(0 15px 30px rgba(0, 0, 0, 0.7));
}

/* ==================== BLOCK 2 (COLLABORATION & FEATURES DESKTOP) ==================== */
.second-container {
    background-color: var(--color-primary);
    /* background-image: linear-gradient(135deg, rgba(221, 24, 20, 1) 0%, rgba(169, 12, 1, 1) 100%); */
    background: linear-gradient(135deg, rgba(221, 24, 20, 1) 0%, rgba(169, 12, 1, 1) 100%),url(../assets/img/test-desk.png);
    background-size: cover;
    background-position: right;
    background-repeat: no-repeat;
    min-height: 100vh;
    padding: 100px clamp(24px, 6vw, 120px);
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    overflow: hidden;
}

.second-content-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1400px;
    gap: 60px;
}

.second-left-block {
    flex: 1 1 550px;
    max-width: 650px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    z-index: 2;
}

.eyebrow-text {
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: clamp(14px, 1.2vw, 24px);
    letter-spacing: 0.05em;
    margin-bottom: 12px;
    opacity: 1;
}

.second-title {
    color: var(--color-white);
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(36px, 3.8vw, 64px);
    line-height: 1.1;
    text-transform: uppercase;
    margin: 0 0 28px 0;
    letter-spacing: 0.02em;
}

.second-description {
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: clamp(15px, 1.2vw, 24px);
    line-height: 1.6;
    margin-bottom: 40px;
}

.second-description p {
    margin-bottom: 16px;
}

.second-description p:last-child {
    margin-bottom: 0;
}

/* Features Grid (2x2 Matrix with dividers) */
.features-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    max-width: 520px;
}

.feature-item {
    padding: 24px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    box-sizing: border-box;
}

.feature-item.border-bottom {
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
}

.feature-item.border-right {
    border-right: 1px solid rgba(255, 255, 255, 0.4);
}

.feature-value {
    color: var(--color-white);
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(28px, 2.5vw, 48px);
    line-height: 1.1;
    text-transform: uppercase;
    margin-bottom: 4px;
}

.feature-label {
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: clamp(13px, 1.2vw, 24px);
    opacity: 0.95;
}

/* Right Block Presentation */
.second-right-block {
    flex: 1 1 500px;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
}

.product-presentation {
    position: relative;
    width: 100%;
    min-height: 520px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.red-radial-glow {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 380px;
    height: 380px;
    background: radial-gradient(circle, rgba(255, 120, 40, 0.6) 0%, rgba(221, 24, 20, 0.4) 40%, rgba(169, 12, 1, 0) 70%);
    filter: blur(50px);
    border-radius: 50%;
    pointer-events: none;
    z-index: 1;
}

.smoke-flame-effect {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 420px;
    height: 420px;
    background: radial-gradient(ellipse at center, rgba(255, 180, 80, 0.3) 0%, rgba(244, 0, 0, 0.15) 50%, rgba(0, 0, 0, 0) 80%);
    filter: blur(35px);
    pointer-events: none;
    z-index: 1;
}

.bottle-detail-img {
    position: relative;
    z-index: 2;
    max-width: 100%;
    max-height: auto;
    object-fit: contain;
    filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.6));
}

.chili-peppers-container {
    position: relative;
    z-index: 3;
    margin-top: -60px;
    width: 100%;
    max-width: 450px;
    display: flex;
    justify-content: center;
}

.chili-img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
    filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.5));
}

.legal-footnote {
    color: var(--color-white);
    font-family: var(--font-family);
    font-weight: 400;
    font-size: clamp(10px, 0.75vw, 12px);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-top: 30px;
    align-self: flex-end;
    text-align: center;
    opacity: 0.85;
}

/* ==================== BLOCK 3 (RECIPES SECTION DESKTOP) ==================== */
.recipes-container {
    background-image: radial-gradient(circle at 50% 30%, rgba(221, 24, 20, 0.2) 0%, rgba(12, 12, 14, 0.95) 75%), url('../assets/img/park-live-third-bg.jpg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: #0c0c0e;
    min-height: 100vh;
    padding: 90px clamp(24px, 6vw, 120px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    overflow: hidden;
}

.recipes-content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    max-width: 1300px;
}

.recipes-header {
    text-align: left;
    max-width: 885px;
    margin-bottom: 50px;
}

.recipes-eyebrow {
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: clamp(14px, 1.4vw, 24px);
    opacity: 1;
    margin-bottom: 8px;
}

.recipes-title {
    color: var(--color-white);
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(36px, 3.8vw, 64px);
    line-height: 1.1;
    text-transform: uppercase;
    margin: 0 0 16px 0;
    letter-spacing: 0.02em;
}

.recipes-subtitle {
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: clamp(15px, 1.2vw, 24px);
    line-height: 1.5;
    margin: 0;
    opacity: 1;
}

/* Desktop Recipes Layout (2 cards without carousel) */
.recipes-grid-desktop {
    display: flex;
    justify-content: center;
    gap: 28px;
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;
}

.recipe-card-slide-desktop {
    flex: 1;
    max-width: 660px;
    box-sizing: border-box;
}

.recipes-cards-track {
    display: flex;
    width: 100%;
    transition: transform var(--transition-normal);
}

@media screen and (max-width: 768px) {
    .recipe-card-slide {
        flex: 0 0 100%;
        max-width: 100%;
    }
}

.recipe-card {
    position: relative;
    height: 540px;
    border-radius: var(--radius-lg);
    overflow: hidden;
    background: var(--color-primary-dark);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.5);
    transition: transform var(--transition-fast), box-shadow var(--transition-fast);
}

.recipe-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 20px 40px rgba(221, 24, 20, 0.4);
}

.recipe-card-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.recipe-card-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.recipe-card-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70%;
    background: linear-gradient(to top, rgba(12, 12, 14, 0.95) 0%, rgba(169, 12, 1, 0.6) 60%, rgba(0, 0, 0, 0) 100%);
}

.recipe-card-body {
    position: relative;
    z-index: 2;
    padding: 24px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
}

.recipe-card-title {
    color: var(--color-white);
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(30px, 3.4vw, 64px);
    line-height: 1.15;
    text-transform: uppercase;
    margin: 0 0 8px 0;
}

.recipe-card-subtitle {
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: clamp(13px, 0.9vw, 24px);
    line-height: 1.3;
    margin: 0 0 20px 0;
    opacity: 1;
}

.btn-recipe-view {
    background: transparent;
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 14px;
    padding: 10px 20px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--color-white);
    cursor: pointer;
    text-transform: uppercase;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all var(--transition-fast);
    margin-top: auto;
}

.btn-recipe-view:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: var(--color-white);
}

/* Pagination Dots */
.carousel-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 36px;
}

.pagination-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.35);
    cursor: pointer;
    transition: all var(--transition-fast);
}

.pagination-dot.active {
    background: var(--color-white);
    transform: scale(1.25);
}

/* RECIPE MODAL WINDOW STYLES */
.recipe-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    padding: 20px;
    box-sizing: border-box;
}

.recipe-modal-content {
    background-color: #111115;
    border-radius: var(--radius-lg);
    border: 1px solid rgba(255, 255, 255, 0.1);
    width: 100%;
    max-width: 900px;
    max-height: 90vh;
    overflow-y: auto;
    padding: 40px;
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    color: var(--color-white);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.8);
}

.recipe-modal-close {
    position: absolute;
    top: 24px;
    right: 24px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity var(--transition-fast);
}

.recipe-modal-close:hover {
    opacity: 0.7;
}

.recipe-modal-header {
    text-align: left;
    margin-bottom: 32px;
}

.recipe-modal-title {
    color: var(--color-white);
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(28px, 2.5vw, 40px);
    text-transform: uppercase;
    margin: 0 0 8px 0;
    letter-spacing: 0.02em;
}

.recipe-modal-tagline {
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    opacity: 0.85;
    margin: 0;
}

.recipe-modal-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    margin-bottom: 0;
    text-align: left;
}

@media screen and (max-width: 768px) {
    .recipe-modal-info {
        grid-template-columns: 1fr;
        gap: 28px;
    }
}

.recipe-section-title-wrap {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
}

.recipe-section-title {
    color: var(--color-primary);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 18px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0;
    white-space: nowrap;
}

.recipe-section-line {
    flex: 1;
    height: 2px;
    background: var(--color-primary);
    opacity: 0.8;
}

/* Ingredients Table/List */
.ingredients-list {
    display: flex;
    flex-direction: column;
}

.ingredient-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    font-size: 15px;
}

.ing-name {
    font-family: var(--font-family-medium);
    color: var(--color-white);
}

.ing-amount {
    font-family: var(--font-family-bold);
    color: var(--color-white);
    opacity: 0.9;
}

/* Steps List */
.steps-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.step-row {
    display: flex;
    align-items: flex-start;
    gap: 14px;
}

.step-number {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: var(--color-primary-dark);
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.step-text {
    color: var(--color-white);
    font-family: var(--font-family);
    font-size: 15px;
    line-height: 1.5;
    margin: 0;
}

/* Video Container */
.recipe-video-container {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: var(--radius-md);
    overflow: hidden;
    background-color: #000;
}

.recipe-video-player {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.video-play-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background var(--transition-fast);
}

.video-play-overlay:hover {
    background: rgba(0, 0, 0, 0.25);
}

.play-button-circle {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background-color: var(--color-white);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
    transition: transform var(--transition-fast);
}

.video-play-overlay:hover .play-button-circle {
    transform: scale(1.1);
}

/* ==================== BLOCK 4 (REGISTRATION DESKTOP) ==================== */
.third-container {
    background-color: var(--color-primary-dark);
    background-image: none;
    min-height: 100vh;
    padding: 100px clamp(24px, 6vw, 120px);
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    position: relative;
}

.reg-content-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    max-width: 1300px;
    gap: 60px;
}

.reg-left-block {
    flex: 1 1 520px;
    max-width: 620px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
}

/* Badge / Pill */
.reg-badge-pill {
    background-color: #000000;
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-size: 20px;
    font-weight: 500;
    padding: 8px 20px;
    border-radius: 50px;
    margin-bottom: 24px;
    display: inline-block;
    letter-spacing: 0.03em;
}

.reg-eyebrow {
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-weight: 300;
    font-size: clamp(14px, 1.3vw, 22px);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 16px;
    opacity: 1;
}

.reg-title {
    color: var(--color-white);
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(50px, 5.0vw, 96px);
    line-height: 1.1;
    text-transform: uppercase;
    margin: 0 0 28px 0;
    letter-spacing: 0.02em;
}

.reg-paragraph {
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: clamp(15px, 1.4vw, 24px);
    line-height: 1.6;
    margin-bottom: 20px;
}

.reg-paragraph strong {
    font-family: var(--font-family-bold);
    font-weight: 700;
}

/* Right Column (Form Container Box) */
.reg-right-block {
    flex: 1 1 500px;
    max-width: 580px;
    width: 100%;
}

.form-card-container {
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: var(--radius-lg);
    background: transparent;
    padding: 44px 36px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    text-align: left;
}

.form-card-title {
    color: var(--color-white);
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(24px, 2.4vw, 36px);
    text-transform: uppercase;
    margin: 0 0 10px 0;
    letter-spacing: 0.02em;
}

.form-card-subtitle {
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-size: 22px;
    font-weight: 500;
    line-height: 1.4;
    margin-bottom: 28px;
    opacity: 1;
}

.form-main-block {
    display: flex;
    flex-direction: column;
    gap: 18px;
    width: 100%;
}

.form-group-item {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.form-input-label {
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 7px;
    text-align: left;
}

.input-wrapper-card {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.input-body-card {
    border: 1px solid var(--color-primary);
    background: transparent;
    color: var(--color-white);
    border-radius: var(--radius-md);
    padding: 14px 18px;
    width: 100%;
    height: 52px;
    font-size: 20px;
    font-weight: 400;
    font-family: var(--font-family);
    box-sizing: border-box;
    transition: border-color var(--transition-fast);
}

.input-body-card:focus {
    border-color: var(--color-white);
    outline: none;
}

.input-body-card::placeholder {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
}
.input-body-mobile-card::placeholder {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
}
/* Custom Vuetify Select inside Card */
.card-select ::v-deep .v-input__slot {
    /* border: 1px solid var(--color-primary) !important; */
    border-radius: var(--radius-md) !important;
    background: transparent !important;
    min-height: 48px !important;
}

.card-select ::v-deep .v-select__selections {
    color: var(--color-white) !important;
    font-size: 20px !important;
    font-family: var(--font-family) !important;
    font-weight: 400 !important;
}

.card-select ::v-deep fieldset {
    border-color: var(--color-primary) !important;
}

.card-select-mobile ::v-deep .v-input__slot {
    border-radius: var(--radius-md) !important;
    background: transparent !important;
    min-height: 48px !important;
}

.card-select-mobile ::v-deep .v-select__selections,
.card-select-mobile ::v-deep .v-select__selections span,
.card-select-mobile ::v-deep input,
.card-select-mobile ::v-deep input::placeholder,
.card-select-mobile ::v-deep .v-select__selection,
.card-select-mobile ::v-deep .v-select__selection--comma,
.card-select-mobile ::v-deep .v-select__placeholder {
    color: var(--color-white) !important;
    font-size: 20px !important;
    font-family: var(--font-family) !important;
    font-weight: 400 !important;
}

.card-select-mobile ::v-deep fieldset {
    border-color: var(--color-primary) !important;
}

/* Checkboxes in Form Card */
.checkboxes-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.checkbox-container-card {
    display: flex;
    align-items: flex-start;
}

.checkbox-content-card {
    position: relative;
    display: flex;
    align-items: flex-start;
}

.custom-checkbox-card {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.checkbox-label-card {
    cursor: pointer;
    font-size: 14px;
    font-family: var(--font-family);
    color: var(--color-white);
    position: relative;
    padding-left: 28px;
    line-height: 1.4;
}

.checkbox-label-card::before {
    content: "";
    position: absolute;
    left: 0;
    top: 2px;
    width: 18px;
    height: 18px;
    border: 1px solid var(--color-white);
    border-radius: 2px;
    background: transparent;
    transition: background-color var(--transition-fast);
}

.checkbox-label-card::after {
    content: "";
    position: absolute;
    left: 6px;
    top: 5px;
    width: 5px;
    height: 9px;
    border: solid transparent;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    transition: border-color var(--transition-fast);
}

.custom-checkbox-card:checked + .checkbox-label-card::before {
    background-color: #000000;
    border-color: #000000;
}

.custom-checkbox-card:checked + .checkbox-label-card::after {
    border-color: var(--color-white);
}

.legal-link {
    color: var(--color-white);
    text-decoration: underline;
    cursor: pointer;
}

/* Submit Button (Outline) */
.btn-submit-container {
    width: 100%;
    display: flex;
    justify-content: center;
}

.btn-form-outline {
    background: transparent;
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 18px;
    padding: 14px 44px;
    border-radius: var(--radius-md);
    border: 1px solid var(--color-white);
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    transition: all var(--transition-fast);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 220px;
}

.btn-form-outline:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: var(--color-white);
    transform: translateY(-2px);
}

.btn-form-outline:active {
    transform: translateY(1px);
    background: rgba(255, 255, 255, 0.05);
}

.form-legal-footer {
    font-size: 11px;
    color: var(--color-white);
    opacity: 0.8;
    text-align: center;
    margin: 0;
    line-height: 1.4;
}

.legal-underline-link {
    color: var(--color-white);
    text-decoration: underline;
    cursor: pointer;
}

.snackbar-btn {
    color: var(--Red, #eb5757);
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;
}



input:focus {
    outline: 1px solid #1976d2;
    /* синяя обводка */
    /* или */
    box-shadow: 0 0 5px #1976d2;
}
.promo-text-container {
    text-align: center;
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: 20px;
    text-align: center;
    color: #fff; /* Используй шрифт проекта */
    max-width: 470px;
}

.promo-text-container p {
    margin: 0;
}

.promo-link {
    color: #ffffff;
    text-decoration: underline;
    cursor: pointer;
    transition: opacity 0.3s ease;
}

.promo-link:hover {
    opacity: 0.8;
}
.header-text {
    font-family: "MontserratBold";
    font-weight: 700;
    font-size: 24px;
    text-transform: uppercase;
    color: #FFFFFF;
}

.popup-close-1 {
    /* font-size: 20px; */
    cursor: pointer;
}

.popup-text-1 {
    font-family: "MontserratMedium";
    font-weight: 400;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 1.6;
    white-space: pre-line;
    padding: 0 15px;
    overflow-y: auto;
    /* скролл только текста */
    flex: 1;
}

.popup-text-1::-webkit-scrollbar {
    width: 8px;
    /* толщина */
}

/* Ползунок */
.popup-text-1::-webkit-scrollbar-thumb {
    background-color: white;
    /* цвет (как на картинке) */
    border-radius: 10px;
    /* закругления */
}

/* Фон скроллбара */
.popup-text-1::-webkit-scrollbar-track {
    background: transparent;
    /* прозрачный трек */
}

.popup-close {
    margin-top: 10px;
    align-self: flex-end;
}

.custom-checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* стили для label */
.checkbox-label {
    /* display: flex;
  align-items: flex-start; */
    cursor: pointer;
    font-size: var(--font-size-md);
    font-weight: 700;
    line-height: 1.3;
    font-family: var(--font-family-bold);
    /* твой кастомный шрифт */
    position: relative;
    padding-left: 24px;
    /* отступ под квадратик */
}

/* кастомный квадратик */
.checkbox-label::before {
    content: "";
    position: absolute;
    left: -8px;
    top: 2px;
    width: 20px;
    height: 20px;
    border: 1px solid var(--color-white);
    border-radius: 2px;
    /* убери, если нужен квадрат без скруглений */
    background-color: transparent;
    transition: border-color 0.2s ease
}

.checkbox-label::after {
    content: "";
    position: absolute;
    left: 0px;
    top: 5px;
    width: 6px;
    height: 10px;
    border: solid transparent;
    /* по умолчанию невидимая */
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    transition: border-color 0.2s ease;
}

/* при checked — черный фон и белая галочка */
.custom-checkbox:checked+.checkbox-label::before {
    background-color: #000000;
}

.custom-checkbox:checked+.checkbox-label::after {
    border-color: #FFFFFF;
    /* галочка белая */
}

/* ---------------------------------------MOBILE */

.third-container-mobile .city-select-container ::v-deep .v-select input::placeholder {
    font-size: 20px !important;
    /* нужный вам размер */
}

.third-container-mobile ::v-deep .v-select input::placeholder {
    white-space: normal !important;
    word-break: break-word;
}

.third-container-mobile ::v-deep .v-select.v-text-field:not(.v-text-field--single-line) input {
    margin-top: 0;
    text-align: left;
}

.third-container-mobile ::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
    min-height: 45px !important;
}

.third-container-mobile ::v-deep .v-select input::placeholder {
    font-family: var(--font-family) !important;
    font-size: 20px !important;
    /* нужный вам размер */
}

.third-container-mobile ::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
    color: var(--color-primary) !important;
    border-radius: 10.64px;
}

.third-container-mobile ::v-deep .v-select.v-input--dense .v-select__selection--comma {
    margin: 0;
    font-size: 20px;
}

.third-container-mobile ::v-deep .v-input__slot {
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    min-height: inherit;
    position: relative;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    transition-property: height, min-height;
    width: 461px;
}

.third-container-mobile ::v-deep .v-input {
    align-items: flex-start;
    display: flex;
    flex: none;
    font-size: 16px;
    letter-spacing: normal;
    max-width: 100%;
    text-align: left;
    height: 50px;
}

.third-container-mobile {
    background-image: url('../assets/img/absolut-form-bg-mobile.png');
    background-size: cover;
    background-position: right;
    /* background-color: #F2E4B5; */
    position: relative;
    height: 100%;
    padding: 40px 0px 30.15px 0px;

}



.third-container-mobile ::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
    padding: 4px 0px;
    color: var(--color-white);
    font-size: 20px;
    font-family: var(--font-family) !important;
    font-weight: 400 !important;
}

.third-container-mobile ::v-deep .v-select input::placeholder {
    color: var(--color-white) !important;
    font-weight: 400 !important;
    font-size: 20px !important;
    font-family: var(--font-family) !important;
}

.third-container-mobile ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0 12px;
    /* min-width: 325px !important; */
    width: 100% !important;
}

.third-container-mobile ::v-deep .v-list-item--dense .v-list-item__title {
    font-size: 18px !important;

}
.form-main label {
    color: var(--color-white);
    font-size: var(--font-size-md);
    font-weight: 700;
    margin-right: 30px;
    text-align: right;
    font-family: var(--font-family-bold);
}

.second-block-title-mobile {
    color: #141097;
    font-weight: 900;
    font-size: 48px;
    text-transform: uppercase;
    margin-bottom: 12px;
    text-align: left;
    font-family: "MontserratBlack";
}

.second-block-description-mobile span {
    font-family: "MontserratBold";
    color: #141097;
    font-weight: 700;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    line-height: 28px;
    text-transform: uppercase;
    text-align: left;
}

.second-first-container-mobile {
    margin: 0px 30px 0px;
}

.number-mobile {
    color: #141097;
    font-size: 40px;
    font-weight: 400;
    margin-bottom: 0px;
    font-family: "MontserratRegular";
}

.condition-text-mobile {
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    line-height: 1.1;
    margin-left: 39.4px;
    font-family: "MontserratBold"
}

.condition-text-mobile span {
    font-weight: 700;
    font-size: 16px;
    color: #141097;
    margin: 25px 0;
    font-family: "MontserratBold";
}

.text-title-mobile {
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(20px, 7vw, 36px);
    text-transform: uppercase;
    text-align: center;
    color: var(--color-white);
    margin-bottom: 0;
    line-height: 1.2;
    overflow-wrap: break-word;
    word-break: break-word;
}
.text-title-main-mobile {
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(14px, 4.8vw, 26px);
    text-transform: uppercase;
    text-align: center;
    color: var(--color-white);
    line-height: 1.25;
    overflow-wrap: break-word;
    word-break: break-word;
    margin-bottom: 24px;
}
.registration-body-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 clamp(10px, 4vw, 33px);
    width: 100%;
    box-sizing: border-box;
    margin: auto;
}

.footer-container-mobile {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
}
.jameson-logo-footer-mobile {
    width: 310px;
    height: 84px;
}
.no-truncate .v-select__selection {
    white-space: normal !important;
    text-overflow: initial !important;
    overflow: visible !important;
}


.first-block-logo-mobile {
    max-width: 320.11px;
    height: 47.02px;
    width: 100%;
    margin-bottom: 5.94px;
}

.first-container-mobile {
    background-image: url('../assets/img/park-live-first-block-bg-mobile.png');
    background-size: cover;
    background-position: right;
    background-repeat: no-repeat;
    min-height: 100vh;
    min-height: 100dvh;
    padding: 50px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    width: 100%;
}

.first-container-mobile .first-block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: center;
    padding: 0;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
}

.second-first-block-mobile {
    padding-top: 32px;
}

.second-second-block-mobile {
    padding-bottom: 296px;
}

.second-second-block-mobile .condition-container:nth-child(-n+3) {
    border-bottom: none;
    max-width: 520px;
}

.logo-container-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
}

.logo-container-footer-2 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 46px;
}

.link-text-mobile {
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin-bottom: 0px;
    font-family: var(--font-family);
}

.politics-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.social-container-mobile {
    display: flex;
    flex-direction: column;
    /* gap: 20px; */
    /* flex-wrap: wrap; */
    justify-content: space-between;
    margin-top: 47px;
}

.main-container-footer-mobile {
    padding: 30px 15px;
    background-color: var(--color-primary);

}

.form-main-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 360px;
    margin: 0 auto;
}

.form-container-mobile {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 6px;
}

.input-name-mobile {
    font-family: "MontserratBold", sans-serif;
    font-weight: 700;
    font-size: 15px;
    color: #141097;
    margin: 0;
    text-align: left;
}

.input-wrapper-mobile {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.input-body-mobile {
    border: 1px solid var(--color-white);
    border-radius: 10px;
    padding: 15px 14px;
    min-width: 325px;
    width: 100%;
    height: 50px;
    font-size: 16px;
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    /* margin-left: auto; */
    /* Выравнивание поля ввода вправо */
}

.input-body-mobile::placeholder {
    color: var(--color-white);
    /* Задайте нужный цвет */
    font-size: 20px;
    font-weight: 700;
    font-family: var(--font-family-bold);
    opacity: 1;
    /* Убедитесь, что текст полностью видим */
}

.title-first-block-mobile {
    color: var(--color-white);
    font-weight: 900;
    font-size: 36px;
    line-height: 1.2;
    margin-top: 24.08px;
    font-family: var(--font-family-black);
    text-align:left;
    text-transform: uppercase;
}

.description-first-block-mobile {
    color: #141097;
    font-weight: 500;
    font-size: 18px;
    line-height: 1.2;
    margin-top: 24px;
    max-width: 360px;
    font-family: "MontserratMedium";
}

.description-first-block-small-mobile {
    font-weight: 500;
    font-size: 13px;
    color: #fff;
    line-height: 1.2;
    margin-bottom: 30px;
    max-width: 360px;
    font-family: "MontserratMedium";
}

.jameson-logo-mobile {
    width: 192.11px;
    height: 48.02px;
    /* margin-bottom: 18px; */
}

.big-img-first-block-mobile {
    max-width: 367.74px;
    max-height: 422.18px;
    width: 100%;
    object-fit: cover;
    border-radius: 5px;
}

.third-container-mobile ::v-deep .v-select__selections {
    display: flex;
    /* оставляем flex */
    align-items: center;
    /* выравнивание по центру */
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    /* ... в конце */
}

.third-container-mobile ::v-deep .v-select__selections span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
}

.third-container-mobile ::v-deep .v-select.v-input {
  width: 100% !important;
  max-width: 100%; 
}
.third-container-mobile ::v-deep .v-select input::placeholder {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: block;
    width: 100%;
    font-family: var(--font-family) !important;
    font-weight: 400 !important;
}

.third-container-mobile ::v-deep .v-select input {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    width: 100% !important;
    display: block;
    font-family: var(--font-family) !important;
    font-weight: 400 !important;
}

@media screen and (max-width: 1250px) {
    .promo-text-container {
        font-size:16px;
        text-align: left;
        max-width: 280px;
    }
    .checkbox-label {
        font-size: 15px;
    }

    /* кастомный квадратик */
    .checkbox-label::before {
        left: 0px;
        width: 15px;
        height: 15px;
    }

    .checkbox-label::after {
        left: 5px;
        top: 3px;
    }

    .checkbox-container label {
        color: black;
        text-align: left;
        font-size: 15px;
        font-weight: 400;
    }

    .third-container {
        padding: 35px 0 0;
    }

    .popup-close-1 {
        font-size: 16px;
    }

    .title-container {
        padding-bottom: 39px;
        padding-top: 0px;
    }

    .form-container {
        justify-content: center;
    }

    .checkbox-container label {
        color: white;
        text-align: left;
    }

    .input-body {
        text-align: left;
    }

    .input-body-mobile {
        text-align: left;
    }

    .footer-second-block {
        text-align: center;
    }

    .footer-first-block, .footer-third-block {
        text-align: center;
        width: 100%;
        margin-right: 0px;
        max-width: 440px;
        margin-top: 30px;
        margin-left: 0px;
    }

    .footer-main-text {
        padding: 5px 0;
    }

    .first-block {
        padding: 25px 0 0 0;
    }

    .popup-header {
        padding: 5px 0;
    }

    .header-text {
        font-family: "MontserratBold";
        font-weight: 700;
        font-size: 16px;
        text-transform: uppercase;
        color: #FFFFFF;
    }

    /* Текст внутри */
    .popup-text-1 {
        font-family: "MontserratMedium";
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 1.6;
        white-space: pre-line;
        padding: 0;
        overflow-y: auto;
        /* скролл только текста */
        flex: 1;
    }

    .popup-close-1 {
        font-size: 16px;
    }
}

@media screen and (max-width: 566px) {
    .checkbox-label::before {
        margin-top: 10px;
    }

    .checkbox-label::after {
        left: 5px;
        top: 13px;
    }
}

@media (max-width: 1617px) and (min-width: 1250px) {
    .title-first-block {
        font-size: clamp(28px, 3.2vw, 44px);
        margin-top: 24px;
        max-width: 730px;
    }

    .description-first-block {
        max-width: 590px;
    }

    .second-first-container {
        margin: 0 120px;
    }
}



@media screen and (max-width: 376px) {
    .form-container[data-v-a608fcba] {
        max-width: 228px;
    }

    .additional {
        padding: 30px 20px 0px 30px;
    }

    .error-message {
        font-size: 12px;
    }

    .input-body-mobile {
        min-width: 100%;
    }

    .addition-height {
        height: 50px;
    }

    .third-container-mobile ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
        max-width: 228px !important;
        min-width: 100% !important;
    }

    .input-body-mobile {
        max-width: 228px !important;
        min-width: 100% !important;
    }

    /* .first-block {
        padding: 15px;
    } */

}

/* ==================== BLOCK 5 (PURCHASE & TIMER XO.KZ DESKTOP) ==================== */
.fifth-container {
    background-color: #000000;
    min-height: 80vh;
    padding: 100px clamp(24px, 6vw, 120px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    position: relative;
}

.fifth-content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    max-width: 900px;
}

.fifth-eyebrow {
    color: var(--color-primary);
    font-family: var(--font-family-medium);
    font-weight: 700;
    font-size: clamp(26px, 1.1vw, 32px);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 12px;
}

.fifth-title {
    color: var(--color-white);
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(36px, 3.8vw, 96px);
    line-height: 1.1;
    text-transform: uppercase;
    margin: 0 0 18px 0;
    letter-spacing: 0.02em;
}

.fifth-subtitle {
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: clamp(15px, 1.2vw, 24px);
    line-height: 1.5;
    max-width: 680px;
    margin: 0 0 44px 0;
    opacity: 1;
    text-align: center;
}

/* Countdown Grid */
.buy-countdown-grid {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-bottom: 44px;
}

.buy-countdown-block {
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: var(--radius-md);
    padding: 18px 24px;
    min-width: 135px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.buy-countdown-number {
    color: var(--color-white);
    font-family: var(--font-family-black);
    font-weight: 700;
    font-size: clamp(42px, 2.5vw, 75px);
    line-height: 1;
    margin-bottom: 6px;
}

.buy-countdown-label {
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: clamp(11px, 1.5vw, 18px);    text-transform: uppercase;
    letter-spacing: 0.05em;
    opacity:0.9;
}

/* Action Container & Buttons */
.buy-action-container {
    margin-bottom: 32px;
    width: 100%;
    display: flex;
    justify-content: center;
}

.btn-buy-disabled {
    background-color: #707070;
    color: #d8d8d8;
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: clamp(15px, 1.1vw, 22px);
    padding: 16px 36px;
    border-radius: var(--radius-md);
    border: none;
    cursor: not-allowed;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    opacity: 0.9;
}

.lock-icon {
    flex-shrink: 0;
}

.btn-buy-active {
    background-color: var(--color-white);
    color: var(--color-primary);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: clamp(16px, 1.2vw, 18px);
    padding: 16px 44px;
    border-radius: var(--radius-md);
    border: none;
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    transition: all var(--transition-fast);
    box-shadow: 0 10px 25px rgba(221, 24, 20, 0.4);
}

.btn-buy-active:hover {
    background-color: #f5f5f5;
    color: var(--color-primary-dark, #A61109);
    transform: translateY(-3px);
    box-shadow: 0 15px 30px rgba(221, 24, 20, 0.6), 0 0 15px rgba(255, 255, 255, 0.2);
}

.btn-buy-active:hover .arrow-icon {
    transform: translateX(4px);
}

.btn-buy-active:active {
    background-color: #e6e6e6;
    color: var(--color-primary, #DD1814);
    transform: translateY(1px);
    box-shadow: 0 5px 15px rgba(221, 24, 20, 0.4);
}

/* Promo Pill Banner */
.promo-pill-banner {
    background-color: var(--color-primary-dark);
    color: var(--color-white);
    border-radius: 50px;
    padding: 12px 28px;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.5);
}

.ticket-icon {
    flex-shrink: 0;
}

.promo-pill-text {
    font-family: var(--font-family-bold);
    font-size: clamp(20px, 0.9vw, 22px);
    color: var(--color-white);
}

.promo-pill-text strong {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 115%;
}

/* ==================== MOBILE CSS FOR ALL 5 BLOCKS ==================== */
.main-container-mobile {
    width: 100%;
    overflow-x: hidden;
}

/* Mobile Block 1 */
.first-container-mobile {
    background-image: radial-gradient(circle at 50% 30%, rgba(221, 24, 20, 0.25) 0%, rgba(12, 12, 14, 0.95) 80%), url('../assets/img/park-live-first-block-bg-mobile.png');
    background-size: cover;
    background-position: right;
    background-color: #0c0c0e;
    min-height: 70vh;
    padding: 40px 20px 60px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
    position: relative;
    width: 100%;
}

.first-block-mobile {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    width: 100%;
    max-width: 480px;
}

.logo-container-mobile {
    margin-bottom: 20px;
}

.brand-logo-mobile {
    max-width: 180px;
    height: auto;
}

.hero-title-mobile {
    color: var(--color-white);
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(28px, 8vw, 42px);
    line-height: 1.1;
    text-transform: uppercase;
    margin: 0 0 12px 0;
    letter-spacing: 0.02em;
}

.hero-subtitle-mobile {
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: clamp(14px, 4vw, 18px);
    text-transform: uppercase;
    margin: 0 0 14px 0;
    letter-spacing: 0.04em;
    opacity: 0.95;
}

.hero-desc-mobile {
    color: var(--color-white);
    font-family: var(--font-family);
    font-size: 15px;
    margin: 0 0 24px 0;
    opacity: 0.9;
}

.hero-buttons-mobile {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
}

.btn-primary-mobile {
    background-color: var(--color-primary-dark);
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 15px;
    padding: 14px 20px;
    border-radius: var(--radius-md);
    border: none;
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    width: 100%;
}

.btn-secondary-mobile {
    background-color: transparent;
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 15px;
    padding: 14px 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--color-white);
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.product-image-container-mobile {
    position: relative;
    width: 100%;
    max-width: 280px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 24px 0;
}

.lava-glow-mobile {
    position: absolute;
    width: 220px;
    height: 220px;
    background: radial-gradient(circle, rgba(244, 0, 0, 0.7) 0%, rgba(221, 24, 20, 0.4) 50%, rgba(0, 0, 0, 0) 80%);
    filter: blur(35px);
    border-radius: 50%;
}

.product-img-mobile {
    position: relative;
    z-index: 2;
    max-width: 100%;
    height: auto;
    max-height: 360px;
    filter: drop-shadow(0 15px 30px rgba(0, 0, 0, 0.6));
}

.countdown-wrapper-mobile {
    display: flex;
    justify-content: center;
    gap: 10px;
    width: 100%;
}

.countdown-item-mobile {
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    padding: 10px 12px;
    min-width: 64px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Mobile Block 2 */
.second-container-mobile {
    background-color: var(--color-primary);
    background-image: url(../assets/img/mob-test.png);
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: #0c0c0e;
    min-height: 100vh;
    padding: 60px 20px;
    color: var(--color-white);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: left;
    box-sizing: border-box;
}

.second-content-mobile {
    width: 100%;
    max-width: 480px;
}

.eyebrow-text-mobile {
    font-family: var(--font-family);
    font-size: 14px;
    opacity: 0.85;
    margin-bottom: 8px;
}

.second-title-mobile {
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(32px, 8vw, 44px);
    line-height: 1.1;
    text-transform: uppercase;
    margin-bottom: 20px;
}

.second-desc-mobile {
    font-family: var(--font-family-medium);
    font-size: 15px;
    line-height: 1.5;
    margin-bottom: 30px;
}

.second-desc-mobile p {
    margin-bottom: 14px;
}

.features-grid-mobile {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    margin-bottom: 40px;
}

.feature-item-mobile {
    padding: 16px 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.product-presentation-mobile {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;
}

.red-radial-glow-mobile {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 240px;
    height: 240px;
    background: radial-gradient(circle, rgba(255, 120, 40, 0.6) 0%, rgba(169, 12, 1, 0) 70%);
    filter: blur(40px);
}

.bottle-detail-img-mobile {
    position: relative;
    z-index: 2;
    max-width: 100%;
    max-height: 380px;
    object-fit: contain;
}

.chili-peppers-container-mobile {
    position: relative;
    z-index: 3;
    margin-top: -40px;
    width: 100%;
    max-width: 320px;
    display: flex;
    justify-content: center;
}

.chili-img-mobile {
    max-width: 100%;
    height: auto;
}

.legal-footnote-mobile {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    opacity: 0.8;
    text-align: center;
}

/* Mobile Block 3 */
.recipes-container-mobile {
    background-color: #0c0c0e;
    background-image: radial-gradient(circle at 50% 30%, rgba(221, 24, 20, 0.2) 0%, rgba(12, 12, 14, 0.95) 75%), url('../assets/img/park-live-third-bg.jpg');
    background-position: top;
    padding: 60px 16px;
    color: var(--color-white);
    text-align: left;
    box-sizing: border-box;
}

.recipes-content-mobile {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
}

.recipes-eyebrow-mobile {
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: 15px;
    opacity: 1;
    margin-bottom: 6px;
}

.recipes-title-mobile {
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(26px, 7vw, 36px);
    line-height: 1.15;
    text-transform: uppercase;
    margin-bottom: 12px;
}

.recipes-subtitle-mobile {
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: 15px;
    line-height: 1.4;
    opacity: 1;
    margin-bottom: 30px;
}

.carousel-outer-mobile {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.carousel-viewport-mobile {
    width: 100%;
    overflow: hidden;
}

.recipe-card-slide-mobile {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0 4px;
    box-sizing: border-box;
}

.recipe-card-mobile {
    position: relative;
    height: 400px;
    border-radius: var(--radius-lg);
    overflow: hidden;
    background: var(--color-primary-dark);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.6);
}

.carousel-arrow-mobile {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    background: rgba(0, 0, 0, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.7);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.arrow-left-mobile {
    left: -10px;
}

.arrow-right-mobile {
    right: -10px;
}

/* Mobile Block 4 */
.third-container-mobile {
        background-color: var(--color-primary-dark);
    background-image: none;
    padding: 60px 20px;
    color: var(--color-white);
    box-sizing: border-box;
}

.reg-content-mobile {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
}

.reg-badge-pill-mobile {
    background-color: #000000;
    color: var(--color-white);
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: 15px;
    padding: 6px 16px;
    border-radius: 50px;
    display: inline-block;
    margin-bottom: 16px;
}

.reg-eyebrow-mobile {
        font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: 15px;
    letter-spacing: 0.05em;
    opacity: 1;
    margin-bottom: 10px;
}

.reg-title-mobile {
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(28px, 7vw, 38px);
    line-height: 1.1;
    text-transform: uppercase;
    margin-bottom: 18px;
}

.reg-paragraph-mobile {
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: 15px;
    line-height: 1.5;
    margin-bottom: 14px;
}

.form-card-container-mobile {
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: var(--radius-lg);
    background: transparent;
    padding: 28px 20px;
    box-sizing: border-box;
    text-align: left;
}

.form-card-title-mobile {
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: 24px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

.form-card-subtitle-mobile {
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: 15px;
    line-height: 1.35;
    margin-bottom: 20px;
    opacity: 1;
}

.form-main-mobile-card {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.form-group-mobile {
    display: flex;
    flex-direction: column;
}

.form-input-label-mobile {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 10px;
}

.input-body-mobile-card {
    border: 1px solid var(--color-primary);
    background: transparent;
    color: var(--color-white);
    border-radius: var(--radius-md);
    padding: 12px 14px;
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: var(--font-family);
    box-sizing: border-box;
}

.btn-form-outline-mobile {
    background: transparent;
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 16px;
    padding: 14px 28px;
    border-radius: var(--radius-md);
    border: 1px solid var(--color-white);
    cursor: pointer;
    text-transform: uppercase;
    width: 100%;
}

/* Mobile Block 5 */
.fifth-container-mobile {
    background-color: #000000;
    padding: 60px 20px;
    color: var(--color-white);
    text-align: center;
    box-sizing: border-box;
}

.fifth-content-mobile {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.fifth-eyebrow-mobile {
    color: var(--color-primary);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

.fifth-title-mobile {
    font-family: var(--font-family-black);
    font-weight: 900;
    font-size: clamp(28px, 7vw, 38px);
    line-height: 1.1;
    text-transform: uppercase;
    margin-bottom: 14px;
}

.fifth-subtitle-mobile {
    font-family: var(--font-family-medium);
    font-weight: 500;
    font-size: 15px;
    line-height: 1.45;
    opacity: 1;
    margin-bottom: 28px;
}

.buy-countdown-grid-mobile {
    display: flex;
    justify-content: center;
    gap: 10px;
    width: 100%;
}

.buy-countdown-block-mobile {
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 8px;
    padding: 12px 14px;
    min-width: 68px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.btn-buy-disabled-mobile {
    background-color: #2a2a2e;
    color: var(--color-white);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 13px;
    padding: 14px 20px;
    border-radius: var(--radius-md);
    border: none;
    cursor: not-allowed;
    text-transform: uppercase;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
}

.btn-buy-active-mobile {
    background-color: var(--color-white);
    color: var(--color-primary);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 15px;
    padding: 14px 24px;
    border-radius: var(--radius-md);
    border: none;
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    transition: all var(--transition-fast);
    box-shadow: 0 8px 20px rgba(221, 24, 20, 0.4);
}

.btn-buy-active-mobile:hover {
    background-color: #f5f5f5;
    color: var(--color-primary-dark, #A61109);
    transform: translateY(-2px);
    box-shadow: 0 12px 25px rgba(221, 24, 20, 0.6);
}

.btn-buy-active-mobile:hover .arrow-icon {
    transform: translateX(4px);
}

.btn-buy-active-mobile:active {
    background-color: #e6e6e6;
    color: var(--color-primary, #DD1814);
    transform: translateY(1px);
    box-shadow: 0 4px 10px rgba(221, 24, 20, 0.4);
}

.promo-pill-banner-mobile {
    background-color: var(--color-primary-dark);
    color: var(--color-white);
    border-radius: 50px;
    padding: 10px 20px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
}

.promo-pill-text-mobile {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 15px;
}
</style>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import Otp from '@/components/otp.vue';
import ConfirmAge1 from "@/components/age-confirm.vue";
import config from "@/config/pageConfig.json";
export default {

    directives: { mask },
    name: "ParkLive",
    components: {
        Otp,
        ConfirmAge1
    },
    data() {
        return {
            showConfirm: true,
            isMobile: window.innerWidth < 1264,
            phone: '',
            items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
            checkbox: false,
            email: '',
            name: '',
            city: '',
            instagram: '',
            product: '',
            surname: '',
            showOtpPopup: false,
            snackbar: false,
            message: "",
            otp: '',
            expectedOtp: '1111',
            loading: false,
            smsTimer: 60, // 60 секунд
            smsTimerInterval: null,
            isSendSms: false,
            isPopupOpen: false,
            currentPopup: null,
            showPopup: false,
            formSchema: null,
            otpSuccess: false,
            otpVerifying: false,
            isLoadingForm: true,
            formError: false,
            otpError: "",
             otpErrorSms: false,
            formData: {},
            errors: {},
            touched: {},
            targetDate: new Date('2026-08-14T00:00:00+05:00').getTime(),
            timeLeft: 0,
            timerInterval: null,
            isFinished: false,
            buyTargetDate: new Date('2026-08-24T00:00:00+05:00').getTime(),
            buyTimeLeft: 0,
            buyDays: 0,
            buyHours: 0,
            buyMinutes: 0,
            buySeconds: 0,
            buyTimerInterval: null,
            isBuyAvailable: false,
            showRecipeModal: false,
            selectedRecipe: null,
            recipeCarouselIndex: 0,
            recipes: [
                {
                    id: 1,
                    title: "SPICY BLOODY MARY",
                    subtitle: "Легендарная Bloody Mary в новом обличии",
                    tagline: "КЛАССИКА БРАНЧА • 5 МИНУТ",
                    image: require("../assets/img/coctail-1.png"),
                    ingredients: [
                        { name: "Absolut Tabasco", amount: "40 мл" },
                        { name: "Томатный сок", amount: "120 мл" },
                        { name: "Щепотка соли и копчёной паприки", amount: "по вкусу" },
                        { name: "Cтебель сельдерея и долька лимона", amount: "" }
                    ],
                    steps: [
                        "Наполнить бокал льдом.",
                        "Налить 50 мл Absolut Tabasco.",
                        "Долить манговый сок.",
                        "Добавить черный перец или смеси лимонного перца.",
                        "Аккуратно перемешать.",
                        "Коктейль готов."                    ]
                },
                {
                    id: 2,
                    title: "SPICY MANGO",
                    subtitle: "Пикантный коктейль с нотками манго и паприки",
                    tagline: "ОСВЕЖАЮЩИЙ И ОСТРЫЙ • 3 МИНУТЫ",
                    image: require("../assets/img/coctail-2.png"),
                    ingredients: [
                        { name: "Absolut Tabasco", amount: "50 мл" },
                        { name: "Манговый сок", amount: " " },
                        { name: "Копчёная паприка или смесь лимонного перца", amount: "" },
                        { name: "Лед", amount: "" }
                    ],
                    steps: [
                        "Наполнить бокал льдом.",
                        "Налить 50 мл Absolut Tabasco.",
                        "Долить манговый сок.",
                        "Добавить небольшую щепотку копчёной паприки или смеси лимонного перца.",
                        "Аккуратно перемешать.",
                        "Коктейль готов."  
                    ]
                }
            ],
            popupTexts: {
                policy: {
                    title: "Политика конфиденциальности",
                    content: `<b>Pernod Ricard Kazakhstan,</b> в качестве оператора персональных данных, уважает ваше
                право на конфиденциальность при использовании веб-сайта
                Цель настоящей Политики конфиденциальности — информировать вас о том, каким
                образом компания Pernod Ricard Kazakhstan собирает, хранит, использует и обрабатывает
                ваши персональные данные, предоставленные через веб-сайт (далее «Веб-сайт»).
                Темы:
                1. Какие персональные данные мы собираем?
                2. Как и зачем мы используем технологии отслеживания?
                3. С какой целью мы используем ваши персональные данные и на каком правовом
                основании?
                4. Что произойдет, если вы откажетесь предоставить свои персональные данные?
                5. Кому мы раскрываем ваши персональные данные и почему?
                6. Передаются ли ваши персональные данные за пределы Казахстана?
                7. Как долго мы храним ваши персональные данные?
                8. Как мы обеспечиваем защиту ваших персональных данных?
                9. Каковы ваши права в отношении ваших персональных данных?
                10. Как с нами связаться или подать жалобу в надзорный орган?
                11. Изменения в Политике конфиденциальности

                <b>1. Какие персональные данные мы собираем?</b>
                Мы собираем следующие персональные данные:
                  Имя, фамилия
                 Дата рождения
                 Адрес электронной почты
                 Пароль
                 Должность
                 Название места работы
                 Фотография
                 IP-адрес
                 Интересы
                <b>Примечание:</b> IP-адрес — это последовательность чисел, используемая для
                идентификации вашего устройства при каждом подключении к интернету.

                <b>2. Как и зачем мы используем технологии отслеживания?</b>
                С вашего согласия, если это требуется по закону, наш Веб-сайт использует файлы cookie и
                подобные технологии отслеживания, такие как IP-адреса или журналы. Эти технологии
                помогают нам:
                 Лучше понимать, как посетители используют наш Веб-сайт и его функции.
                 Улучшать их функциональность.
                 Предоставлять контент, соответствующий вашим интересам.
                
                <b>Подробнее о cookies:</b> см. Политику использования файлов cookie.

                <b>3. С какой целью мы используем ваши персональные данные и на каком</b>
                правовом основании?
                <b>Pernod Ricard Kazakhstan</b> обрабатывает ваши данные в следующих целях:
                 Предоставление доступа к Веб-сайту и создание профиля пользователя.
                 Обеспечение доступа к функциям сайта (например, доступ к онлайн-контенту,
                участие в тренингах, регистрация на мероприятия).
                 Отправка административных уведомлений и сервисных сообщений.
                Мы также можем адаптировать наш контент в зависимости от ваших интересов для
                улучшения вашего опыта на сайте.
                При наличии вашего согласия данные могут использоваться для отправки маркетинговых
                сообщений.

                <b>4. Что произойдет, если вы откажетесь предоставить свои персональные
                данные?</b>
                Если вы решите не предоставлять запрашиваемые данные, вы не сможете:
                 Участвовать в некоторых активностях.
                 Пользоваться персонализированными функциями.
                 Получать специальные услуги.
                <b>Пример:</b> без адреса электронной почты вы не сможете получать наши рассылки. Однако
                вы можете просматривать сайт без предоставления данных.

                <b>5. Кому мы раскрываем ваши персональные данные и почему?</b>
                <b>В рамках группы Pernod Ricard</b>
                Ваши данные могут быть переданы аффилированным компаниям группы Pernod Ricard.
                <b>Третьи стороны</b>
                Ваши данные могут быть переданы третьим сторонам в следующих случаях:
                 <b>Техническая поддержка:</b> провайдеры, агенты или подрядчики.
                 <b>Организация мероприятий и тренингов.</b>
                 <b>По закону:</b> для защиты прав и безопасности компании или общества.
                 <b>Слияние или поглощение:</b> передача данных новому владельцу в соответствии с
                законом.

                <b>6. Передаются ли ваши персональные данные за пределы Казахстана?</b>
                Данные могут передаваться за границу с соблюдением всех необходимых мер защиты,
                включая стандартные договорные положения Европейской комиссии.

                <b>7. Как долго мы храним ваши персональные данные?</b>
                Данные хранятся:
                 Пока ваш аккаунт активен.
                 Пока это необходимо для предоставления функций сайта.
                Также данные могут храниться для выполнения правовых обязательств.

                <b>8. Как мы обеспечиваем защиту ваших персональных данных?</b>
                <b>Pernod Ricard Kazakhstan</b> принимает все необходимые меры для защиты ваших данных,
                включая:
                 Хранение данных в защищенных операционных средах.
                 Доступ к данным только у уполномоченных сотрудников и подрядчиков.

                <b>9. Каковы ваши права в отношении ваших персональных данных?</b>
                Вы имеете право:
                 Отозвать согласие на обработку данных.
                 Запросить доступ, исправление или удаление данных.
                 Ограничить обработку или запросить перенос данных.
                 Возражать против обработки.

                <b>10. Как с нами связаться или подать жалобу в надзорный орган?</b>
                По вопросам и жалобам, связанным с Политикой конфиденциальности, обращайтесь по
                адресу:
                <b>Алматы, Казахстан, Рубинштейна, 48, 050060</b>

                Или по электронной почте: <b>promo.kz@pernod-ricard.com.</b>

                <b>11. Изменения в Политике конфиденциальности</b>
                Мы регулярно обновляем нашу Политику конфиденциальности и размещаем изменения
                на этой странице.
                <b>Дата последнего обновления:</b> ноябрь 2024 года.`,
                },
                offer: {
                    title: "СОГЛАСИЕ НА СБОР И ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ (для клиентов и потенциальных клиентов)",
                    content: `Я подтверждаю, что достиг возраста 21 года и более и даю <b>ТОО «Перно Рикар
                Казахстан», (БИН 050840001045),</b> а также их работникам и третьим лицам-соисполнителям по
                заключенным между ними договорам, <b>свое согласие</b> на сбор, обработку,
                распространение и трансграничную передачу (без дополнительных уведомлений)
                моих персональных данных, относящихся исключительно к перечисленным ниже
                категориям персональных данных:
                 1) ФИО
                 2) Город проживания
                 3) Мобильный телефон
                 4) E-mail
                <b>Согласованная цель сбора и обработки персональных данных</b> – пополнение CRM
                базы посредством предоставления персональных данных любыми средствами связи
                для участия в активностях, проводимых в отношении товарных знаков продукции
                ТОО «Перно Рикар Казахстан».
                Я даю согласие на использование персональных данных исключительно в
                вышеуказанных целях, а также на обработку персональных данных и их
                трансграничную передачу на всех электронных носителях, используемых для
                вышеуказанной цели.
                Настоящее согласие предоставляется мной на осуществление действий в отношении
                моих персональных данных, которые необходимы для достижения указанных выше
                целей, включая (без ограничения) сбор, систематизацию, накопление, хранение,
                уточнение (обновление, изменение), использование, передачу третьим лицам для
                осуществления действий по обмену информацией, обезличивание, блокирование
                персональных данных, трансграничную передачу персональных данных на территорию любого государства, в том числе не обеспечивающего защиту персональных данных, распространение моих персональных данных в общедоступных источниках,
                а также осуществление любых иных действий,
                предусмотренных действующим законодательством Республики Казахстан.
                Я предоставляю согласие на контактирование со мной для вышеуказанных целей путем осуществления разговора, телефонных звонков, направления мне уведомлений с использованием почты, телефона (также SMS), социальных сетей и/или мессенджеров, вебсайтов, электронной почты, электронных информационных ресурсов и иных информационных систем и мобильных приложений. 
                Я проинформирован, что вышеуказанные компании гарантируют обработку моих
                персональных данных в соответствии с действующим законодательством Республики
                Казахстан как неавтоматизированным, так и автоматизированным способами.
                Данное согласие действует в течение срока хранения информации в вышеуказанных
                целях.
                Данное согласие может быть отозвано в любой момент по моему письменному заявлению, отправленному в адрес Компании по ее юридическому адресу, зарегистрированному на дату отправки заявления или посредством направления электронного сообщения на электронную почту Компании: promo.kz@pernod-ricard.com. В случае отзыва настоящего согласия все мои Персональные данные подлежат уничтожению из базы данных Компании. 
Я подтверждаю, что для включения моих персональных данных в базу данных, в том числе партнеров указанных компаний, передачи, распространения, дополнения и прочей обработки моих персональных данных указанными компаниями с вышеупомянутой целью не требуется дополнительного уведомления меня о совершении данных действий. 

Я подтверждаю, что, давая настоящее согласие, я действую по собственной воле, в своих интересах и полностью осознаю суть и цели подписываемого документа. `,
                },
                rules: {
                    title: "УСЛОВИЯ ПРОВЕДЕНИЯ АКТИВАЦИИ ABSOLUT TABASCO",
                    content: `          <b>1. Общие положения</b>

                    1.1. Настоящие Условия определяют порядок проведения активации Absolut Tabasco (далее — «Активация»).
                    1.2. Организатор Активации: ТОО «Pernod Ricard Kazakhstan» (далее — «Организатор»).
                    1.3. Активация проводится в целях привлечения интереса со стороны потребителя, не содержит элементов риска, не требует внесения платы или покупки товара для участия и не является лотереей в понимании законодательства Республики Казахстан.
                    1.4. Регистрация заявок на участие проводится на посадочной странице (лендинге): https://absolut.prk-events.kz/absolut (далее — «Сайт»).

                    <b>2. Сроки проведения</b>

                    2.1. Приём заявок (регистрация на Сайте): с 00:00 (Алматы) 13 августа 2026 г. по 12:00 (Алматы) 20 августа 2026 г.
                    2.2. Проведение розыгрыша и определение победителя случайным образом: 20 августа 2026 г.
                    2.3. Объявление результатов и передача приза: до 21 августа 2026 г. включительно.

                    <b>3. Территория проведения</b>

                    3.1. Активация проводится на территории Республики Казахстан. Участвовать могут только граждане Республики Казахстан и лица, постоянно проживающие (имеющие статус резидента) на территории РК.

                    <b>4. Участники Активации</b>

                    4.1. К участию допускаются дееспособные физические лица, достигшие 21 (двадцати одного) года на дату регистрации.
                    4.2. Не могут участвовать сотрудники Организатора, аффилированных компаний, агентств, задействованных в организации Активации, и их близкие родственники.
                    4.3. Регистрируясь на Сайте, участник подтверждает, что достиг указанного возраста, является жителем/резидентом РК и относится к употреблению алкоголя ответственно.
                    4.4. Организатор вправе запросить у победителя документ, удостоверяющий личность, для подтверждения возраста и статуса резидента РК перед передачей приза.

                    <b>5. Условия и порядок участия</b>

                    5.1. Для участия необходимо в период, указанный в п. 2.1, заполнить регистрационную форму на Сайте, указав следующие данные:
                    - имя;
                    - номер телефона;
                    - e-mail;
                    - город проживания.
                    5.2. Участник подтверждает достоверность указанных данных и даёт согласие на обработку персональных данных в целях проведения Активации.
                    5.3. Один участник — одна заявка. Повторные заявки с одного номера телефона / e-mail / устройства при розыгрыше не учитываются.
                    5.4. Организатор вправе не учитывать заявки с неполными, недостоверными или некорректными данными, а также заявки лиц, не соответствующих условиям п. 3.1 и п. 4.1.

                    <b>6. Призовой фонд</b>

                    6.1. Призовой фонд Активации: 2 (два) трёхдневных абонемента на фестиваль Park Live.
                    6.2. Количество победителей: 1 (один). Оба абонемента передаются одному победителю («в одни руки»).
                    6.3. Приз не подлежит замене на денежный эквивалент и передаче третьим лицам без согласования с Организатором.

                    <b>7. Порядок определения победителя</b>

                    7.1. Победитель определяется случайным образом среди всех участников, подавших корректную заявку в срок, установленный п. 2.1.
                    7.2. Организатор связывается с победителем по контактным данным, указанным при регистрации, в день проведения розыгрыша — 20 августа 2026 г.
                    7.3. Если победитель не выходит на связь до 12:00 (Алматы) 21 августа 2026 г., Организатор вправе определить другого победителя.

                    <b>8. Прочие условия</b>

                    8.1. Организатор вправе вносить изменения в настоящие Условия, включая сроки Активации, с обязательным размещением актуальной версии на Сайте.
                    8.2. Факт регистрации на Сайте означает полное согласие участника с настоящими Условиями.`,
                }
            },
            config: {
                ...config,

                // bgLogoMainMobile: require(`@/assets/img/${config.bgLogoMainMobile}`),
                // bgLogoMain: require(`@/assets/img/${config.bgLogoMain}`),
                // logoMain: require(`@/assets/img/${config.logoMain}`),
                // logoMainMobile: require(`@/assets/img/${config.logoMainMobile}`),
                // logoInvisible: require(`@/assets/img/${config.logoInvisible}`),
                // bigImage: require(`@/assets/img/${config.bigImage}`),
                // bigImageMobile: require(`@/assets/img/${config.bigImageMobile}`),
                // footer: {
                //     ...config.footer,
                //     logoMainFooter: require(`@/assets/img/${config.footer.logoMainFooter}`),
                //     logoMainMobileFooter: require(`@/assets/img/${config.footer.logoMainMobileFooter}`),
                //     logo: require(`@/assets/img/${config.footer.logo}`),
                //     // Если есть другие картинки в футере — добавь их сюда
                // }
            }
        };
    },
    created() {
        if (localStorage.getItem("userAge") !== null) {
            this.showConfirm = false
        }
    },
    computed: {
        days() {
            return Math.floor(this.timeLeft / (1000 * 60 * 60 * 24));
        },
        hours() {
            return Math.floor((this.timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        },
        minutes() {
            return Math.floor((this.timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        },
        seconds() {
            return Math.floor((this.timeLeft % (1000 * 60)) / 1000);
        },
        ...mapGetters(['getUserAge']),
        filteredQuestions() {
            if (!this.formSchema?.questions) return [];
            return this.formSchema.questions.filter(q => (q.type === 11 || q.type === 12));
        },
        normalQuestions() {
            if (!this.formSchema?.questions) return [];
            return this.formSchema.questions.filter(q => (q.type !== 11 && q.type !== 3 && q.type !== 12));
        }

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        if (this.buyTimerInterval) {
            clearInterval(this.buyTimerInterval);
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        console.log('Возраст пользователя:', this.getUserAge);
        this.getFormFields();
        this.updateTimer(); // Вызываем сразу, чтобы не было задержки в 1 секунду
        this.timerInterval = setInterval(this.updateTimer, 1000);

        this.updateBuyTimer();
        this.buyTimerInterval = setInterval(this.updateBuyTimer, 1000);
    },
    watch: {
        formData: {
            deep: true,
            handler(val) {
                for (let [id, value] of Object.entries(val)) {
                    this.validateField(id, value);
                }
            }
        },
        getUserAge(newVal) {
            if (!newVal || !this.formSchema) return;

            const birthQuestion = this.formSchema.questions.find(q => q.type === 3);
            if (birthQuestion) {
                this.$set(this.formData, birthQuestion.id, newVal);
                console.log("NEW DATA");
            }
        }
    },
    methods: {
        scrollToForm() {
            const el = this.isMobile
                ? (this.$refs.formSectionMobile || document.getElementById('registration-form-mobile'))
                : (this.$refs.formSection || document.getElementById('registration-form'));
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        scrollToRecipe() {
            const el = this.isMobile
                ? (this.$refs.recipeSectionMobile || document.getElementById('recipes-container-mobile'))
                : (this.$refs.recipeSection || document.getElementById('recipes-container'));
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        updateTimer() {
            const now = Date.now();
            const difference = this.targetDate - now;

            if (difference <= 0) {
                this.timeLeft = 0;
                this.isFinished = true;
                clearInterval(this.timerInterval);
            } else {
                this.timeLeft = difference;
            }
        },
        updateBuyTimer() {
            const now = Date.now();
            const difference = this.buyTargetDate - now;

            if (difference <= 0) {
                this.buyTimeLeft = 0;
                this.buyDays = 0;
                this.buyHours = 0;
                this.buyMinutes = 0;
                this.buySeconds = 0;
                this.isBuyAvailable = true;
                if (this.buyTimerInterval) {
                    clearInterval(this.buyTimerInterval);
                }
            } else {
                this.isBuyAvailable = false;
                this.buyTimeLeft = difference;
                this.buyDays = Math.floor(difference / (1000 * 60 * 60 * 24));
                this.buyHours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                this.buyMinutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                this.buySeconds = Math.floor((difference % (1000 * 60)) / 1000);
            }
        },
        getBuyUrl() {
            const baseUrl = "https://newxo.kz/product/vodka-absolut-tabasco-07-l";
            const defaultUtm = "?utm_source=landing&utm_medium=referral&utm_campaign=at_launch";

            let userUtmSource = "";
            if (this.$route && this.$route.query && this.$route.query.utm_source) {
                userUtmSource = this.$route.query.utm_source;
            } else {
                try {
                    const urlParams = new URLSearchParams(window.location.search);
                    userUtmSource = urlParams.get("utm_source") || "";
                } catch (e) {
                    userUtmSource = "";
                }
            }

            if (userUtmSource) {
                return `${baseUrl}${defaultUtm}&utm_content=${encodeURIComponent(userUtmSource)}`;
            }
            return `${baseUrl}${defaultUtm}`;
        },
        goToStore() {
            if (!this.isBuyAvailable) return;
            const finalUrl = this.getBuyUrl();
            console.log("[UTM/Analytics] Redirecting to store:", finalUrl);
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: "click_buy_xo_kz",
                    url: finalUrl
                });
            }
            window.open(finalUrl, "_blank");
        },
        padNumber(num) {
            // Добавляет ведущий ноль, если число меньше 10 (например, "05" вместо "5")
            return num < 10 ? '0' + num : num;
        },
        onConfirmed() {
            this.showConfirm = false
            console.log("Компонент закрыт")
            // localStorage.setItem("ageConfirmed", "1")
        },
        handleResize() {
            const wasMobile = this.isMobile;
            this.isMobile = window.innerWidth < 1264;
            if (wasMobile !== this.isMobile) {
                this.recipeCarouselIndex = 0;
            }
        },
        //     onFinish (rsp) {
        //     this.loading = true
        //     setTimeout(() => {
        //       this.loading = false
        //       this.snackbarColor = (rsp === this.expectedOtp) ? 'success' : 'warning'

        //     }, 3500)
        //   },
        validateField(question) {
            const value = this.formData[question.id];
            let error = null;

            // Проверка только для текстовых полей (например id 1,2,7,4)
            if ([1, 2, 4, 7].includes(question.type)) {
                if (!value || value.trim() === "") {
                    error = "Поле обязательно";
                }
            }
            if ([11].includes(question.type)) {
                if (!value && this.touched[question.id]) {
                    error = "Вы должны принять условия.";
                }
            }
            if ([12].includes(question.type)) {
                if (!value && this.touched[question.id]) {
                    error = "Вы должны принять условия.";
                }
            }
            if (error === null) {
                if ([1].includes(question.type)) {
                    // Имя только буквы
                    if (!/^[А-Яа-яA-Za-zӘәҒғҚқҢңӨөҰұҮүҺһІі\s-]+$/.test(value)) {
                        error = "Введите корректное имя.";
                    }
                }

                if ([2].includes(question.type)) {
                    // Фамилия только буквы
                    if (!/^[А-Яа-яA-Za-zӘәҒғҚқҢңӨөҰұҮүҺһІі\s-]+$/.test(value)) {
                        error = "Введите корректную фамилию.";
                    }
                }

                if ([7].includes(question.type)) {
                    // Email
                    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
                        error = "Введите корректный email.";
                    }
                }

                if ([4].includes(question.type)) {
                    // Телефон
                    if (!/^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(value)) {
                        error = "Введите корректный номер телефона.";
                    }
                }
            }

            this.$set(this.errors, question.id, error);
        },
        markTouched(question) {
            this.$set(this.touched, question.id, true);
            this.validateField(question);
        },
        getPlaceholder(question) {
            switch (question.type) {
                case 5:
                    return "Город";
                case 9:
                    return "Какой Absolut вы предпочитаете?";
                case 10:
                    return "Введите логин";
                default:
                    return question.name;
            }
        },
        getFormFields() {
            this.isLoadingForm = true;
            this.formError = false;
            this.$http.get('/api/survey', {
                params: {
                    campaignId: "fdb08218-6395-f111-b801-00155d79212a"
                }
            })
                .then(res => {
                    this.formSchema = res.data;
                    res.data.questions.forEach(q => {
                        if (q.type === 3) {
                            this.$set(this.formData, q.id, this.getUserAge);
                        } else {
                            this.$set(this.formData, q.id, "");
                        }
                    });
                })
                .catch(err => {
                    this.formError = true;
                    console.error("Ошибка загрузки формы", err);
                })
                .finally(() => {
                    this.isLoadingForm = false;
                });
        },
        submitForm() {
            console.log("Отправка формы:", this.formData);
            // пример отправки
            // this.$http.post("/api/survey/submit", this.formData)
        },
        openPopup(type) {
            this.currentPopup = type
            this.isPopupOpen = true
        },
        goTo(url) {
            window.open(url, '_blank'); // Откроется в новой вкладке
        },
        logCity() {
            console.log(this.city);
        },
        logNumber() {
            console.log(this.phone);
        },
        async sendVerificationCode() {
            const phoneQuestion = this.formSchema.questions.find(q => q.type === 4);
            if (!phoneQuestion) return;

            const phoneAnswerRaw = this.formData[phoneQuestion.id];
            const phoneAnswer = phoneAnswerRaw.replace(/[^\d+]/g, "");
            // Готовим DTO
            try {
                this.isSendSms = true; // Блокируем кнопку, пока идет проверка капчи
                await this.$recaptchaLoaded();
                const recaptchaToken = await this.$recaptcha('send_sms'); 
            const answerDto = {
                campaignId: "fdb08218-6395-f111-b801-00155d79212a",
                surveyAnswer: {
                    surveyQuestionId: phoneQuestion.id,
                    answer: phoneAnswer
                },
                recaptchaToken: recaptchaToken,
            };
                await this.$http.post("/api/Verification/SendCode", answerDto);
                console.log("Код отправлен!");
                this.otpErrorSms = false;
                return true;
            } catch (err) {
                console.error("Ошибка при отправке кода:", err);
                if (err?.response?.status === 409) {
                    // пользователь уже зарегистрирован
                    // this.formData = {};
                    this.otpErrorSms = true;
                    this.showOtpPopup = true;
                    this.otpSuccess = false;
                    return false;
                }
                if (err?.response?.status === 403) {
                    // Бэкенд отбил запрос из-за низкого score капчи
                    this.snackbar = true;
                    this.message = 'Подозрение на бота. Попробуйте перезагрузить страницу.';
                    return false;
                }
            } finally {
                this.isSendSms = false;
            }
        },
        async resendSms() {
            // можно просто вызвать sendVerificationCode ещё раз
            await this.startSmsTimer();
            await this.sendVerificationCode();
        },
        async confirmRegistration() {
            // Проверка на заполненность всех полей
            this.otpError = "";
            if (!this.formSchema) return;
            console.log(this.formData);
            const hasEmptyField = Object.keys(this.formData).some(key => {
                const value = this.formData[key];
                console.log(this.formData);
                const type = this.formSchema.questions.find(q => q.id === this.formData[key])?.type; // допустим, вопросы в массиве

                if (type === 11 || type === 12) {
                    // чекбокс — false = ошибка
                    return value === false;
                }

                // для остальных — пустые значения
                return value === null || value === undefined || value === '';
                // return value === null || value === undefined || value === '' || value === false;
            });

            // Проверка: есть ли ошибки валидации
            const hasErrors = Object.values(this.errors).some(error => error && error.length > 0);
            console.log("Erors", this.errors);
            if (hasEmptyField || hasErrors) {
                this.snackbar = true;
                this.message = hasErrors
                    ? 'Исправьте ошибки в форме перед отправкой'
                    : 'Пожалуйста, заполните все поля';
                return;
            }
            try {
                console.log(this.formData);
                this.isSendSms = true;
                const isSent = await this.sendVerificationCode();
                    // Открываем попап только если СМС реально ушло и нет 409 ошибки
                    if (isSent && !this.otpErrorSms) {  // 👈 только если не было 409
                    this.otpError = "";
                    this.otpSuccess = false;
                    this.showOtpPopup = true;
                    this.startSmsTimer();
                }
            } catch {
                this.snackbar = true;
                this.message = 'Ошибка при отправке кода. Попробуйте снова.';
            }
            finally {
            this.isSendSms = false;
            }
        },
        async submitAnswersWithCode(code) {
            this.otpVerifying = true;
            this.otpError = "";
            this.otpSuccess = false;
            try {
                const payload = {
                    surveyId: this.formSchema.id,
                    campaignId: "fdb08218-6395-f111-b801-00155d79212a",
                    verificationCode: code,
                    answers: Object.entries(this.formData).map(([key, value]) => {
                        let answer = String(value);

                        if (/^\+7[\d\s()-]{10,}$/.test(answer)) {
                            answer = answer.replace(/[^\d+]/g, '');
                        }

                        return {
                            surveyQuestionId: key,
                            answer
                        };
                    })
                };

                await this.$http.post('/api/AnswerSet', payload);
                this.otpSuccess = true;
                this.formData = {};
                // this.showOtpPopup = false; // закрыть попап
            } catch (error) {
                console.error(error);
                const msg = error?.response?.data?.message || "Код введён неверно";
                this.otpError = msg;
            } finally {
                this.otpVerifying = false;
            }
        },
        async startSmsTimer() {
            this.smsTimer = 60;
            if (this.smsTimerInterval) clearInterval(this.smsTimerInterval);
            this.smsTimerInterval = setInterval(() => {
                if (this.smsTimer > 0) {
                    this.smsTimer--;
                } else {
                    clearInterval(this.smsTimerInterval);
                    this.smsTimerInterval = null;
                    // Здесь можно вызвать метод компонента otp через $refs, если нужно
                }
            }, 1000);
        },
        onPhoneFocus(question) {
            if (!this.formData[question.id]) {
                this.$set(this.formData, question.id, '+7');
            }
        },
        onPhoneInput(question) {
            const val = this.formData[question.id] || '';
            if (!val.startsWith('+7')) {
                this.formData[question.id] = '+7' + val.replace(/\D/g, '').slice(1);
            }
            this.validateField(question);
        },
        closePopup() {
            this.showPopup = false;
            this.isPopupOpen = false; // Закрыть pop-up
            // Очистка полей
            this.phone = '';
            this.email = '';
            this.name = '';
            this.city = '';
            this.surname = '';
            this.checkbox = false;
        },
        nextRecipeSlide() {
            const maxIndex = this.recipes.length - 1;
            if (this.recipeCarouselIndex < maxIndex) {
                this.recipeCarouselIndex++;
            } else {
                this.recipeCarouselIndex = 0;
            }
        },
        prevRecipeSlide() {
            const maxIndex = this.recipes.length - 1;
            if (this.recipeCarouselIndex > 0) {
                this.recipeCarouselIndex--;
            } else {
                this.recipeCarouselIndex = maxIndex;
            }
        },
        setRecipeSlide(index) {
            this.recipeCarouselIndex = index;
        },
        openRecipeModal(recipe) {
            this.selectedRecipe = recipe;
            this.showRecipeModal = true;

            // Событие 1 по брифу: Клик по кнопке «Смотреть рецепт» открывает модальное окно и отправляет аналитику
            console.log("[Analytics] View Recipe Event Sent:", recipe.title, recipe.id);
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: "view_recipe",
                    recipe_name: recipe.title,
                    recipe_id: recipe.id
                });
            }
        },
        closeRecipeModal() {
            this.showRecipeModal = false;
        },
    }
}


</script>